var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformatique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-computer-troubleshooting",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-computer-troubleshooting:not(.animated) .animable {opacity: 0;}svg#freepik_stories-computer-troubleshooting.animated #freepik--Floor--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn,1.5s Infinite  linear wind;animation-delay: 0s,1s;}svg#freepik_stories-computer-troubleshooting.animated #freepik--Shadows--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-computer-troubleshooting.animated #freepik--gears-2--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut,1.5s Infinite  linear wind;animation-delay: 0s,1s;}svg#freepik_stories-computer-troubleshooting.animated #freepik--Barrier--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-computer-troubleshooting.animated #freepik--Device--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-computer-troubleshooting.animated #freepik--gears-1--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-computer-troubleshooting.animated #freepik--speech-bubble-2--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-computer-troubleshooting.animated #freepik--speech-bubble-1--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-computer-troubleshooting.animated #freepik--Screwdriver--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-computer-troubleshooting.animated #freepik--Character--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-computer-troubleshooting.animated #freepik--Cone--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}            @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 334.33px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-2",
    cx: 250,
    cy: 334.33,
    rx: 243.61,
    ry: 145.8,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 334.33px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "251.388px 365.913px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-2",
    cx: 424.74,
    cy: 400.62,
    rx: 64.6,
    ry: 37.3,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "424.74px 400.62px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M18.66,385.83s4.29,2.47,13.24,0L101.39,426c4.28,2.47,23.17,5.73,23.17,5.73l36.4,21,6.8,2.33.81-.42-4.3-3.82-36.4-21s-9.93-9.55-13.24-11.46L45.14,378.18s4-5.31,0-7.64C40.08,368.63,15,382.6,18.66,385.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "93.4333px 412.711px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M54.24,351.3l-40.1-23.23a1,1,0,0,1,0-1.91l96.07-55.47a3.71,3.71,0,0,1,3.31,0l40.16,23.19a1,1,0,0,1,0,1.91L57.55,351.3A3.64,3.64,0,0,1,54.24,351.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "83.91px 310.999px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M328.39,461l-32.64-18.84a1.34,1.34,0,0,1,0-2.54l32.64-18.84a4.83,4.83,0,0,1,4.38,0l32.64,18.84a1.34,1.34,0,0,1,0,2.54L332.77,461A4.83,4.83,0,0,1,328.39,461Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "330.58px 440.89px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears-2--inject-2",
    className: "animable",
    style: {
      transformOrigin: "248.196px 130.834px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Gear--inject-2",
    d: "M159.76,93.8h0a19.68,19.68,0,0,1-3.26,0,20.06,20.06,0,0,1-3.21-.5,1,1,0,0,1-.78-1.09l.19-2.72a15.89,15.89,0,0,1-3.95-2l-2.05,1.77a1,1,0,0,1-1.35,0,19.89,19.89,0,0,1-4.24-4.9,1,1,0,0,1,.22-1.33l2.06-1.78a16,16,0,0,1-1.39-4.2l-2.71-.2a1,1,0,0,1-1-.93,19.27,19.27,0,0,1,.47-6.48,1,1,0,0,1,1.09-.78l2.71.2a16.28,16.28,0,0,1,2-4l-1.78-2.06a1.06,1.06,0,0,1,0-1.35,19.71,19.71,0,0,1,4.92-4.23,1,1,0,0,1,1.32.22l1.78,2a15.57,15.57,0,0,1,4.2-1.38l.2-2.72a1,1,0,0,1,.93-1,19.57,19.57,0,0,1,3.25,0,20,20,0,0,1,3.22.5,1,1,0,0,1,.78,1.09l-.2,2.72a16.13,16.13,0,0,1,4,2l2-1.77a1.06,1.06,0,0,1,1.35,0,19.76,19.76,0,0,1,4.24,4.91,1,1,0,0,1-.22,1.32L172.48,67a16.19,16.19,0,0,1,1.39,4.2l2.71.2a1,1,0,0,1,1,.94,19.54,19.54,0,0,1,0,3.25,20.79,20.79,0,0,1-.5,3.21,1,1,0,0,1-1.09.79h0l-2.71-.2a16.28,16.28,0,0,1-2,4l1.77,2.06a1,1,0,0,1,0,1.34A19.53,19.53,0,0,1,168.16,91a1,1,0,0,1-1.32-.21l-1.78-2.06a16.05,16.05,0,0,1-4.2,1.38l-.2,2.72A1,1,0,0,1,159.76,93.8Zm-11.13-7.37a.45.45,0,0,1,.35.09,15.11,15.11,0,0,0,4.36,2.18.51.51,0,0,1,.35.51l-.23,3.1a14.82,14.82,0,0,0,3.09.54,19.89,19.89,0,0,0,3.09,0l.27-3.15a.48.48,0,0,1,.41-.45A15.17,15.17,0,0,0,165,87.69a.48.48,0,0,1,.6.12l2,2.34a17.27,17.27,0,0,0,4.73-4l-2-2.42a.48.48,0,0,1,0-.61,15.21,15.21,0,0,0,2.19-4.35.51.51,0,0,1,.51-.35l3.09.23a.06.06,0,0,0,.06,0,18.87,18.87,0,0,0,.47-3.06,18.6,18.6,0,0,0,0-3.08l-3.15-.28a.49.49,0,0,1-.45-.41,15.16,15.16,0,0,0-1.53-4.64.48.48,0,0,1,.12-.6l2.35-2a17.63,17.63,0,0,0-4-4.73l-2.42,2a.5.5,0,0,1-.61,0,14.89,14.89,0,0,0-4.36-2.19.51.51,0,0,1-.35-.51l.23-3.1a14.18,14.18,0,0,0-3.09-.53,18.73,18.73,0,0,0-3.09,0l-.27,3.16a.5.5,0,0,1-.41.45,15,15,0,0,0-4.64,1.52.49.49,0,0,1-.6-.11l-2-2.35a17.46,17.46,0,0,0-4.74,4l2,2.41a.5.5,0,0,1,0,.61,15.22,15.22,0,0,0-2.2,4.37.5.5,0,0,1-.51.34l-3.09-.23a14.63,14.63,0,0,0-.54,3.09,17.83,17.83,0,0,0,0,3.1l3.14.27a.5.5,0,0,1,.46.41,14.84,14.84,0,0,0,1.53,4.63.49.49,0,0,1-.11.6l-2.36,2a17.63,17.63,0,0,0,4,4.73l2.42-2A.5.5,0,0,1,148.63,86.43Zm10.63-2.85a9.53,9.53,0,0,1-9.9-13.6A9,9,0,0,1,155,65.09a9.56,9.56,0,0,1,11.46,13.28,9,9,0,0,1-5.66,4.88h0A10.84,10.84,0,0,1,159.26,83.58ZM156.7,65.75a8.83,8.83,0,0,0-1.41.29,8,8,0,0,0-5,4.34,8.58,8.58,0,0,0,10.29,11.93h0a8,8,0,0,0,5-4.35,8.66,8.66,0,0,0-1.22-9.35A8.55,8.55,0,0,0,156.7,65.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "157.924px 74.07px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--gear--inject-2",
    d: "M460.58,84.41h0a19.57,19.57,0,0,1-3.25,0,20,20,0,0,1-3.22-.5,1,1,0,0,1-.78-1.09l.2-2.72a15.79,15.79,0,0,1-4-2l-2.05,1.77a1,1,0,0,1-1.35,0A19.89,19.89,0,0,1,441.9,75a1,1,0,0,1,.22-1.33l2.06-1.78a16.32,16.32,0,0,1-1.39-4.2l-2.71-.2a1,1,0,0,1-1-.93,19.27,19.27,0,0,1,.47-6.48,1,1,0,0,1,1.09-.78l2.71.2a16.28,16.28,0,0,1,2-3.95l-1.78-2.06a1,1,0,0,1,0-1.35A19.49,19.49,0,0,1,448.5,48a1,1,0,0,1,1.32.22l1.78,2a15.57,15.57,0,0,1,4.2-1.38l.2-2.72a1,1,0,0,1,.93-1,19.68,19.68,0,0,1,3.26,0,19.88,19.88,0,0,1,3.21.5,1,1,0,0,1,.78,1.09l-.2,2.72a16,16,0,0,1,4,2L470,49.65a1.06,1.06,0,0,1,1.35,0,19.76,19.76,0,0,1,4.24,4.91,1,1,0,0,1-.22,1.32l-2.06,1.78a16.19,16.19,0,0,1,1.39,4.2l2.71.2a1,1,0,0,1,1,.94,19.54,19.54,0,0,1,0,3.25,20.79,20.79,0,0,1-.5,3.21,1,1,0,0,1-1.09.79h0l-2.71-.2a16.1,16.1,0,0,1-2,4L473.87,76a1,1,0,0,1,0,1.34,19.66,19.66,0,0,1-4.9,4.24,1.05,1.05,0,0,1-1.33-.21l-1.77-2.06a16.24,16.24,0,0,1-4.21,1.38l-.2,2.72A1,1,0,0,1,460.58,84.41ZM449.45,77a.45.45,0,0,1,.35.09,15.11,15.11,0,0,0,4.36,2.18.51.51,0,0,1,.35.51l-.23,3.1a14.82,14.82,0,0,0,3.09.54,19.89,19.89,0,0,0,3.09,0l.27-3.15a.49.49,0,0,1,.41-.45,15.17,15.17,0,0,0,4.64-1.53.48.48,0,0,1,.6.12l2,2.34a17.2,17.2,0,0,0,4.72-4l-2-2.42a.48.48,0,0,1,0-.61,15.21,15.21,0,0,0,2.19-4.35.51.51,0,0,1,.51-.35l3.09.23a.06.06,0,0,0,.06,0,20.07,20.07,0,0,0,.48-3.06,18.59,18.59,0,0,0,0-3.08l-3.14-.28a.49.49,0,0,1-.46-.41,15.16,15.16,0,0,0-1.53-4.64.49.49,0,0,1,.12-.6l2.35-2a17.63,17.63,0,0,0-4-4.73l-2.42,2a.5.5,0,0,1-.61,0,14.89,14.89,0,0,0-4.36-2.19.51.51,0,0,1-.35-.51l.23-3.1a14.18,14.18,0,0,0-3.09-.53,18.73,18.73,0,0,0-3.09,0l-.27,3.16a.5.5,0,0,1-.41.45,15,15,0,0,0-4.64,1.52.49.49,0,0,1-.6-.11l-2-2.35a17.46,17.46,0,0,0-4.74,4l2,2.41a.5.5,0,0,1,0,.61,15.22,15.22,0,0,0-2.2,4.37.5.5,0,0,1-.51.34l-3.09-.23a14.63,14.63,0,0,0-.54,3.09,17.83,17.83,0,0,0,0,3.1l3.15.27a.5.5,0,0,1,.45.41,15.11,15.11,0,0,0,1.53,4.63.49.49,0,0,1-.11.6l-2.36,2a17.63,17.63,0,0,0,4,4.73l2.42-2A.54.54,0,0,1,449.45,77Zm10.63-2.85a9.53,9.53,0,0,1-9.9-13.6,9,9,0,0,1,5.66-4.89A9.56,9.56,0,0,1,467.3,69a9,9,0,0,1-5.66,4.88h0A10.84,10.84,0,0,1,460.08,74.19Zm-2.55-17.83a9,9,0,0,0-1.42.29,8,8,0,0,0-5,4.34,8.58,8.58,0,0,0,10.29,11.93h0a8,8,0,0,0,5-4.35,8.66,8.66,0,0,0-1.22-9.35A8.55,8.55,0,0,0,457.53,56.36Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "458.734px 64.765px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--gear--inject-2",
    d: "M196.23,45.27a7.36,7.36,0,0,0-4.61,4,7.74,7.74,0,0,0,7,11.11,9.24,9.24,0,0,0,1-.07,7.83,7.83,0,0,0,1.26-.26,7.3,7.3,0,0,0,4.6-4,7.76,7.76,0,0,0-9.3-10.79Zm8.44,10.39a6.38,6.38,0,0,1-4,3.45,6.81,6.81,0,0,1-8.18-9.47A6.47,6.47,0,0,1,197.61,46a7.11,7.11,0,0,1,.92-.06,6.84,6.84,0,0,1,5.17,2.33A6.91,6.91,0,0,1,204.67,55.66Zm9.76-4.47a.9.9,0,0,0-.84-.82l-2.12-.16a12.91,12.91,0,0,0-1.09-3.28L212,45.54a.93.93,0,0,0,.18-1.17,15.83,15.83,0,0,0-3.42-4,.94.94,0,0,0-1.19,0L206,41.81a13,13,0,0,0-3.09-1.55l.16-2.12a.92.92,0,0,0-.7-1,15.71,15.71,0,0,0-2.59-.4,15.38,15.38,0,0,0-2.63,0,.9.9,0,0,0-.83.84l-.15,2.13a12.63,12.63,0,0,0-3.28,1.08l-1.39-1.61a.92.92,0,0,0-1.17-.19,16,16,0,0,0-4,3.42.92.92,0,0,0,0,1.19l1.39,1.6a13.39,13.39,0,0,0-1.56,3.09l-2.11-.15a.91.91,0,0,0-1,.69,15.18,15.18,0,0,0-.41,2.59,15.53,15.53,0,0,0,0,2.64.92.92,0,0,0,.85.82l2.12.16a12.71,12.71,0,0,0,1.09,3.27l-1.62,1.39a.93.93,0,0,0-.18,1.17,16.06,16.06,0,0,0,3.42,4,.92.92,0,0,0,1.19,0l1.6-1.38a13.76,13.76,0,0,0,3.09,1.55l-.16,2.12a.92.92,0,0,0,.7,1,15.71,15.71,0,0,0,2.59.4c.4,0,.8,0,1.2,0s1,0,1.44-.07h0a.92.92,0,0,0,.79-.85l.16-2.12a12.89,12.89,0,0,0,3.28-1.08l1.39,1.61a.92.92,0,0,0,1.17.19,16,16,0,0,0,4-3.43.92.92,0,0,0,0-1.19L209.42,60A13.28,13.28,0,0,0,211,57l2.12.15a.9.9,0,0,0,1-.69,16.7,16.7,0,0,0,.4-2.6A15.38,15.38,0,0,0,214.43,51.19Zm-.93,2.56a14.35,14.35,0,0,1-.37,2.41L210.67,56a.48.48,0,0,0-.49.33,12,12,0,0,1-1.75,3.48.47.47,0,0,0,0,.59L210,62.27a13.63,13.63,0,0,1-3.67,3.12l-1.59-1.83a.46.46,0,0,0-.58-.11,12.2,12.2,0,0,1-3.7,1.22.46.46,0,0,0-.4.43l-.21,2.47a14.91,14.91,0,0,1-2.41,0,11.43,11.43,0,0,1-2.4-.41l.18-2.43a.46.46,0,0,0-.34-.48,12.24,12.24,0,0,1-3.48-1.75.52.52,0,0,0-.34-.09.47.47,0,0,0-.25.11L189,64.12a13.88,13.88,0,0,1-3.12-3.68l1.84-1.59a.47.47,0,0,0,.11-.58,12,12,0,0,1-1.23-3.7.46.46,0,0,0-.43-.39L183.67,54a14.92,14.92,0,0,1,0-2.41,11.9,11.9,0,0,1,.41-2.4l2.42.18h0A.46.46,0,0,0,187,49a12.46,12.46,0,0,1,1.76-3.49.47.47,0,0,0,0-.59L187.11,43a14.2,14.2,0,0,1,3.68-3.12l1.59,1.84a.47.47,0,0,0,.58.11,11.93,11.93,0,0,1,3.7-1.22.47.47,0,0,0,.4-.43l.21-2.47a14.9,14.9,0,0,1,2.41,0,11.45,11.45,0,0,1,2.4.4l-.18,2.43a.47.47,0,0,0,.34.49,12.24,12.24,0,0,1,3.48,1.75.48.48,0,0,0,.59,0l1.89-1.59a14,14,0,0,1,3.12,3.67l-1.84,1.59a.47.47,0,0,0-.11.58,12,12,0,0,1,1.22,3.7.48.48,0,0,0,.44.4l2.46.22A14.77,14.77,0,0,1,213.5,53.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "198.563px 52.6218px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--gear--inject-2",
    d: "M418.6,44.76a7.35,7.35,0,0,0-4.61,4,7.84,7.84,0,0,0,1.12,8.45A7.74,7.74,0,0,0,421,59.84a8.89,8.89,0,0,0,1-.06,11,11,0,0,0,1.27-.26,7.32,7.32,0,0,0,4.6-4,7.76,7.76,0,0,0-9.3-10.78ZM427,55.15a6.38,6.38,0,0,1-4,3.45,6.81,6.81,0,0,1-8.18-9.47,6.36,6.36,0,0,1,4-3.45,7.46,7.46,0,0,1,1.12-.24,7.09,7.09,0,0,1,.92,0,6.8,6.8,0,0,1,5.17,2.33A6.91,6.91,0,0,1,427,55.15Zm9.76-4.47a.91.91,0,0,0-.84-.83l-2.12-.15a13.17,13.17,0,0,0-1.09-3.28L434.37,45a.93.93,0,0,0,.18-1.17,15.83,15.83,0,0,0-3.42-4,.94.94,0,0,0-1.19,0l-1.6,1.39a12.61,12.61,0,0,0-3.09-1.55l.16-2.12a.91.91,0,0,0-.7-1,15.72,15.72,0,0,0-2.59-.41,16.46,16.46,0,0,0-2.63,0,.92.92,0,0,0-.83.85l-.15,2.12a13,13,0,0,0-3.28,1.08l-1.39-1.6a.92.92,0,0,0-1.17-.19,15.82,15.82,0,0,0-4,3.42.92.92,0,0,0,0,1.18l1.39,1.61a13.39,13.39,0,0,0-1.56,3.09l-2.11-.16a.92.92,0,0,0-1,.69,16.09,16.09,0,0,0-.39,5.24.92.92,0,0,0,.85.82l2.12.16a12.71,12.71,0,0,0,1.09,3.27l-1.62,1.39a.93.93,0,0,0-.18,1.17,16.06,16.06,0,0,0,3.42,4,.94.94,0,0,0,1.19,0l1.6-1.39a13,13,0,0,0,3.09,1.55l-.16,2.13a.9.9,0,0,0,.7,1,15.72,15.72,0,0,0,2.59.41c.4,0,.8,0,1.2,0s1,0,1.44-.06h0a.9.9,0,0,0,.79-.84l.16-2.12A13.29,13.29,0,0,0,426.67,64l1.39,1.6a.91.91,0,0,0,1.17.19,15.62,15.62,0,0,0,4-3.43.91.91,0,0,0,0-1.18l-1.39-1.6a13.35,13.35,0,0,0,1.55-3.09l2.12.16a.91.91,0,0,0,1-.7,16.51,16.51,0,0,0,.4-2.6A15.26,15.26,0,0,0,436.8,50.68Zm-.93,2.55a14.46,14.46,0,0,1-.37,2.42L433,55.47a.48.48,0,0,0-.49.33,12,12,0,0,1-1.75,3.48.47.47,0,0,0,0,.59l1.58,1.89a14,14,0,0,1-3.67,3.12L427.15,63a.49.49,0,0,0-.58-.11,12.2,12.2,0,0,1-3.7,1.22.48.48,0,0,0-.4.44l-.21,2.47a14.91,14.91,0,0,1-2.41,0,12.12,12.12,0,0,1-2.4-.41l.18-2.43a.48.48,0,0,0-.34-.49A12,12,0,0,1,413.81,62a.42.42,0,0,0-.34-.09.47.47,0,0,0-.25.11l-1.89,1.59a14,14,0,0,1-3.12-3.68l1.84-1.59a.48.48,0,0,0,.11-.58,12.13,12.13,0,0,1-1.23-3.7.47.47,0,0,0-.43-.4L406,53.45A14.92,14.92,0,0,1,406,51a11.9,11.9,0,0,1,.41-2.4l2.42.17h0a.47.47,0,0,0,.45-.34A12.53,12.53,0,0,1,411.1,45a.47.47,0,0,0,0-.59l-1.59-1.89a14.2,14.2,0,0,1,3.68-3.12l1.59,1.84a.49.49,0,0,0,.58.11,11.93,11.93,0,0,1,3.7-1.22.47.47,0,0,0,.4-.44l.21-2.46a14.89,14.89,0,0,1,2.41,0,12.12,12.12,0,0,1,2.4.41l-.18,2.43a.48.48,0,0,0,.34.49,11.74,11.74,0,0,1,3.48,1.75.47.47,0,0,0,.59,0l1.89-1.59a14.2,14.2,0,0,1,3.12,3.68l-1.84,1.59a.47.47,0,0,0-.11.58,11.93,11.93,0,0,1,1.22,3.7.49.49,0,0,0,.44.4l2.46.21A14.78,14.78,0,0,1,435.87,53.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "420.931px 52.0337px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--gear--inject-2",
    d: "M46.63,167.65a6.38,6.38,0,0,0-4,3.48,6.85,6.85,0,0,0,1,7.39,6.85,6.85,0,0,0,6.06,2.28,7.06,7.06,0,0,0,1.11-.23,6.35,6.35,0,0,0,4-3.48,6.79,6.79,0,0,0-8.15-9.44Zm7.39,9.1a5.54,5.54,0,0,1-3.5,3,6,6,0,0,1-7.16-8.3,5.59,5.59,0,0,1,3.5-3,7.16,7.16,0,0,1,1-.21,7.31,7.31,0,0,1,.8-.05A5.95,5.95,0,0,1,54,176.75Zm8.56-3.92a.79.79,0,0,0-.74-.72L60,172A10.88,10.88,0,0,0,59,169.1l1.42-1.22a.81.81,0,0,0,.16-1,14.29,14.29,0,0,0-3-3.48.82.82,0,0,0-1,0l-1.41,1.21a11.6,11.6,0,0,0-2.7-1.36l.14-1.86a.8.8,0,0,0-.61-.83,14.08,14.08,0,0,0-2.28-.36,13.57,13.57,0,0,0-2.3,0,.79.79,0,0,0-.72.74l-.14,1.86a10.88,10.88,0,0,0-2.87,1l-1.22-1.41a.79.79,0,0,0-1-.16,13.63,13.63,0,0,0-3.48,3,.81.81,0,0,0,0,1l1.21,1.41a11.6,11.6,0,0,0-1.36,2.7L36,170.21a.78.78,0,0,0-.84.6,13.53,13.53,0,0,0-.36,2.28,13.72,13.72,0,0,0,0,2.31.81.81,0,0,0,.74.72l1.86.13a11.52,11.52,0,0,0,1,2.87l-1.41,1.22a.81.81,0,0,0-.17,1,13.89,13.89,0,0,0,3,3.47.8.8,0,0,0,1,0l1.41-1.22a11.59,11.59,0,0,0,2.7,1.36l-.13,1.86a.79.79,0,0,0,.6.84,13.21,13.21,0,0,0,2.28.35c.35,0,.7,0,1,0s.84,0,1.26-.06h0a.8.8,0,0,0,.69-.74l.14-1.86a11.57,11.57,0,0,0,2.88-.94l1.21,1.4a.8.8,0,0,0,1,.17,13.71,13.71,0,0,0,3.48-3,.79.79,0,0,0,0-1l-1.21-1.41a11.22,11.22,0,0,0,1.36-2.7l1.85.14a.8.8,0,0,0,.84-.61,15,15,0,0,0,.36-2.28A13.56,13.56,0,0,0,62.58,172.83Zm-.81,2.24a12.85,12.85,0,0,1-.33,2.11L59.29,177a.4.4,0,0,0-.43.29,10.5,10.5,0,0,1-1.54,3,.44.44,0,0,0,0,.52l1.4,1.66a12.16,12.16,0,0,1-3.23,2.73l-1.39-1.6a.4.4,0,0,0-.5-.1,11,11,0,0,1-3.25,1.07A.42.42,0,0,0,50,185l-.18,2.16a13.5,13.5,0,0,1-2.11,0,10.31,10.31,0,0,1-2.11-.36l.16-2.13a.41.41,0,0,0-.29-.42,10.78,10.78,0,0,1-3.05-1.53.42.42,0,0,0-.3-.08.37.37,0,0,0-.22.1l-1.66,1.39a12.5,12.5,0,0,1-2.73-3.22l1.61-1.4a.42.42,0,0,0,.1-.51,10.76,10.76,0,0,1-1.08-3.24.4.4,0,0,0-.38-.34l-2.15-.19a12.39,12.39,0,0,1,0-2.11A10.55,10.55,0,0,1,36,171l2.13.16h0a.41.41,0,0,0,.39-.29,10.87,10.87,0,0,1,1.54-3.06.41.41,0,0,0,0-.51l-1.4-1.66A12.35,12.35,0,0,1,41.87,163l1.39,1.61a.43.43,0,0,0,.51.1A10.13,10.13,0,0,1,47,163.59a.41.41,0,0,0,.35-.38l.19-2.17a13.37,13.37,0,0,1,2.1,0,10.78,10.78,0,0,1,2.11.36l-.16,2.13a.43.43,0,0,0,.3.43A10.53,10.53,0,0,1,55,165.48a.42.42,0,0,0,.51,0l1.66-1.4a12.62,12.62,0,0,1,2.74,3.23l-1.62,1.39a.41.41,0,0,0-.1.5,10.55,10.55,0,0,1,1.08,3.25.41.41,0,0,0,.38.35l2.16.19A13.37,13.37,0,0,1,61.77,175.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "48.6807px 174.076px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--gear--inject-2",
    d: "M31.51,202.15a7.37,7.37,0,0,0-4.6,4A7.83,7.83,0,0,0,28,214.57a7.74,7.74,0,0,0,5.89,2.67,9.06,9.06,0,0,0,1-.07,8.18,8.18,0,0,0,1.27-.26,7.35,7.35,0,0,0,4.6-4,7.77,7.77,0,0,0-9.31-10.79ZM40,212.54A6.34,6.34,0,0,1,36,216a6.81,6.81,0,0,1-8.18-9.47,6.34,6.34,0,0,1,4-3.45,7.55,7.55,0,0,1,1.13-.23,7,7,0,0,1,.91-.06A6.78,6.78,0,0,1,40,212.54Zm9.77-4.47a.91.91,0,0,0-.85-.82l-2.11-.16a13.31,13.31,0,0,0-1.09-3.28l1.61-1.39a.92.92,0,0,0,.19-1.17,16.05,16.05,0,0,0-3.43-4,.91.91,0,0,0-1.18,0l-1.61,1.38a13.16,13.16,0,0,0-3.09-1.55l.16-2.12a.92.92,0,0,0-.69-1,15.83,15.83,0,0,0-2.6-.4,15.26,15.26,0,0,0-2.62,0,.89.89,0,0,0-.83.84l-.16,2.13a12.88,12.88,0,0,0-3.28,1.08l-1.38-1.61a.92.92,0,0,0-1.17-.19,16.24,16.24,0,0,0-4,3.42.94.94,0,0,0,0,1.19l1.39,1.6a13.35,13.35,0,0,0-1.55,3.09l-2.12-.15a.91.91,0,0,0-1,.69,17.45,17.45,0,0,0-.41,2.59A16.64,16.64,0,0,0,18,211a.91.91,0,0,0,.85.82L21,212a13.52,13.52,0,0,0,1.09,3.27l-1.61,1.4a.92.92,0,0,0-.19,1.17,15.85,15.85,0,0,0,3.43,4,.91.91,0,0,0,1.18,0l1.61-1.38a13.28,13.28,0,0,0,3.08,1.55l-.15,2.12a.92.92,0,0,0,.69,1,15.83,15.83,0,0,0,2.6.4c.4,0,.8.05,1.2.05a13.88,13.88,0,0,0,1.44-.07h0a.92.92,0,0,0,.79-.84l.16-2.13a13,13,0,0,0,3.28-1.08L41,223a.92.92,0,0,0,1.17.19,15.89,15.89,0,0,0,4-3.43.91.91,0,0,0,0-1.18l-1.38-1.61a13.28,13.28,0,0,0,1.55-3.08l2.12.15a.9.9,0,0,0,.95-.69,15.61,15.61,0,0,0,.41-2.6A15.38,15.38,0,0,0,49.72,208.07Zm-.93,2.56a16.73,16.73,0,0,1-.37,2.41L46,212.86a.47.47,0,0,0-.49.33,12.24,12.24,0,0,1-1.75,3.48.48.48,0,0,0,0,.59l1.59,1.89a14.05,14.05,0,0,1-3.68,3.13l-1.58-1.84a.48.48,0,0,0-.58-.11,12.26,12.26,0,0,1-3.71,1.22.47.47,0,0,0-.4.43l-.21,2.47a14.78,14.78,0,0,1-2.4,0,11.64,11.64,0,0,1-2.41-.41l.18-2.43a.46.46,0,0,0-.33-.48,12.24,12.24,0,0,1-3.48-1.75.53.53,0,0,0-.34-.09.44.44,0,0,0-.25.11L24.24,221a13.88,13.88,0,0,1-3.12-3.68L23,215.73a.49.49,0,0,0,.11-.58,12.07,12.07,0,0,1-1.23-3.69.46.46,0,0,0-.43-.4L19,210.84a16.16,16.16,0,0,1,0-2.41,11.89,11.89,0,0,1,.42-2.4l2.42.18h0a.47.47,0,0,0,.45-.33A12.17,12.17,0,0,1,24,202.39a.48.48,0,0,0,0-.59l-1.6-1.89a14.25,14.25,0,0,1,3.69-3.12l1.58,1.84a.48.48,0,0,0,.58.11,12,12,0,0,1,3.7-1.22.48.48,0,0,0,.41-.43l.21-2.47a14.78,14.78,0,0,1,2.4,0,11.66,11.66,0,0,1,2.41.4l-.18,2.43a.46.46,0,0,0,.33.49A12,12,0,0,1,41,199.68a.48.48,0,0,0,.59,0l1.9-1.59a13.88,13.88,0,0,1,3.12,3.68l-1.84,1.58a.47.47,0,0,0-.12.58,12.31,12.31,0,0,1,1.23,3.7.47.47,0,0,0,.43.4l2.47.22A14.77,14.77,0,0,1,48.79,210.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "33.8771px 209.542px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Barrier--inject-2",
    className: "animable",
    style: {
      transformOrigin: "76.5056px 279.266px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--barrier--inject-2",
    className: "animable",
    style: {
      transformOrigin: "76.5056px 279.266px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.28,287.05l-4.38,2.52a1.74,1.74,0,0,1-1.6,0l-1.39-.8a1.36,1.36,0,0,1-.61-1.36l14.55-68.88a2.39,2.39,0,0,1,1-1.36l4.38-2.53a1.78,1.78,0,0,1,1.59,0l1.4.81a1.35,1.35,0,0,1,.6,1.36L98.26,285.69A2.36,2.36,0,0,1,97.28,287.05Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "101.061px 252.109px"
    },
    id: "elwqa579666ha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.28,287.05l-4.38,2.52c-.44.26-.72.06-.61-.44l14.55-68.87a2.34,2.34,0,0,1,1-1.36l4.39-2.53c.43-.26.71-.06.6.44L98.26,285.69A2.36,2.36,0,0,1,97.28,287.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "102.56px 252.97px"
    },
    id: "el90t4rzg3h54",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.94 282.55 96.24 276.4 99.22 274.68 126.87 290.65 128.17 298.29 125.19 300.01 94.94 282.55",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "111.555px 287.345px"
    },
    id: "elkyooe5oguoo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.19 300.01 94.94 282.55 96.24 276.4 123.89 292.37 125.19 300.01",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "110.065px 288.205px"
    },
    id: "elmbgub6ro03r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.12,306l-4.38,2.53a1.78,1.78,0,0,1-1.59,0l-1.4-.81a2.21,2.21,0,0,1-1-1.36l-14.62-86.11a1.43,1.43,0,0,1,.64-1.36l4.39-2.53a1.72,1.72,0,0,1,1.59,0l1.39.8a2.22,2.22,0,0,1,1,1.37l14.62,86.1A1.42,1.42,0,0,1,130.12,306Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "118.946px 262.441px"
    },
    id: "el1itw5c3uxun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.18,220.26l.55,3.26,14.07,82.84a2.28,2.28,0,0,0,1,1.37l1.4.81a1.78,1.78,0,0,0,1.59,0l4.38-2.53a1.44,1.44,0,0,0,.64-1.37l-14.57-85.81,0-.29a2.23,2.23,0,0,0-1-1.37l-1.39-.81a1.8,1.8,0,0,0-1.6,0l-4.38,2.53A1.44,1.44,0,0,0,107.18,220.26Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "118.997px 262.45px"
    },
    id: "elw9r2njzu4un",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.14,218.54l14.62,86.1a1.42,1.42,0,0,1-.64,1.37l-4.38,2.53a.6.6,0,0,1-.95-.45L110.17,222a1.41,1.41,0,0,1,.64-1.37l4.38-2.53A.6.6,0,0,1,116.14,218.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "120.465px 263.32px"
    },
    id: "elr3giaioq4qg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el02yhybij8oud"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.15,221.88l2.29,1.33a3.47,3.47,0,0,0,2.29.31,2.68,2.68,0,0,0,.89-.31l7.57-4.38,0-.29a2.23,2.23,0,0,0-1-1.37l-1.39-.81a1.8,1.8,0,0,0-1.6,0c.11-.49.44-.66,0-.91l-1.39-.81a1.78,1.78,0,0,0-1.59,0l-4.38,2.53a2.36,2.36,0,0,0-1,1.36Z",
    style: {
      opacity: 0.15,
      transformOrigin: "109.67px 219.023px"
    },
    className: "animable",
    id: "eluxwdw2qk7q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.49,216.52a1.08,1.08,0,0,1,.66-.93l8.76-5.06a3.5,3.5,0,0,1,3.18,0l4.29,2.47a1.13,1.13,0,0,1,.66.91c0,.34,0,1.67,0,2a1.13,1.13,0,0,1-.66.92l-8.76,5a3.53,3.53,0,0,1-3.18,0l-4.29-2.48a1.11,1.11,0,0,1-.66-.91C100.48,218.16,100.49,216.85,100.49,216.52Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "109.263px 216.178px"
    },
    id: "elutwv7nasqki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.49,216.52a1.08,1.08,0,0,1,.66-.93l5.88-3.4v10.08a3.28,3.28,0,0,1-1.59-.38l-4.29-2.48a1.11,1.11,0,0,1-.66-.91C100.48,218.16,100.49,216.85,100.49,216.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.758px 217.23px"
    },
    id: "elc7sfyplb3qe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.62,219.9l8.76-5.06a1,1,0,0,0,0-1.84l-4.29-2.47a3.5,3.5,0,0,0-3.18,0l-8.76,5.06a1,1,0,0,0,0,1.83l4.29,2.48A3.5,3.5,0,0,0,108.62,219.9Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "109.271px 215.215px"
    },
    id: "el045pseyo9sl8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.59,326.7l-4.38,2.53a1.78,1.78,0,0,1-1.59,0l-1.4-.8a1.35,1.35,0,0,1-.6-1.36l14.55-68.88a2.3,2.3,0,0,1,1-1.36l4.38-2.53a1.78,1.78,0,0,1,1.59,0l1.4.8a1.35,1.35,0,0,1,.6,1.36L29.57,325.34A2.3,2.3,0,0,1,28.59,326.7Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "32.38px 291.765px"
    },
    id: "elx1f6yjo1fk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.59,326.7l-4.38,2.53c-.44.25-.71.06-.61-.44l14.55-68.88a2.39,2.39,0,0,1,1-1.36L43.52,256c.44-.25.71,0,.6.44L29.57,325.34A2.3,2.3,0,0,1,28.59,326.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "33.8619px 292.62px"
    },
    id: "el05xcg2b2fzgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.17 322.31 27.47 316.16 30.46 314.44 58.11 330.41 59.41 338.05 56.42 339.77 26.17 322.31",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "42.79px 327.105px"
    },
    id: "elj2pno779c0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.42 339.77 26.17 322.31 27.47 316.16 55.12 332.13 56.42 339.77",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "41.295px 327.965px"
    },
    id: "eluqgiewfcta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.43,345.66l-4.38,2.53a1.72,1.72,0,0,1-1.59,0l-1.39-.8a2.22,2.22,0,0,1-1-1.37L38.5,259.92a1.42,1.42,0,0,1,.64-1.37L43.52,256a1.78,1.78,0,0,1,1.59,0l1.39.81a2.18,2.18,0,0,1,1,1.36L62.07,344.3A1.39,1.39,0,0,1,61.43,345.66Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "50.2855px 302.099px"
    },
    id: "elc5oakjhvts5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5,259.92l.55,3.25L53.12,346a2.22,2.22,0,0,0,.94,1.37l1.4.8a1.8,1.8,0,0,0,1.6,0l4.37-2.52a1.45,1.45,0,0,0,.65-1.37L47.51,258.49l0-.29a2.28,2.28,0,0,0-1-1.37l-1.4-.81a1.78,1.78,0,0,0-1.59,0l-4.39,2.53A1.43,1.43,0,0,0,38.5,259.92Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "50.2886px 302.095px"
    },
    id: "elzhb7kj88q3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.45,258.19,62.07,344.3a1.39,1.39,0,0,1-.64,1.36l-4.38,2.53a.59.59,0,0,1-.95-.44L41.48,261.64a1.41,1.41,0,0,1,.64-1.36l4.38-2.53A.59.59,0,0,1,47.45,258.19Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "51.7757px 302.97px"
    },
    id: "elr8d5ifiaa4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrcxjpabdflm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.46,261.54l2.29,1.32a3.44,3.44,0,0,0,2.3.31,2.85,2.85,0,0,0,.89-.31l7.57-4.37,0-.29a2.28,2.28,0,0,0-1-1.37l-1.4-.81a1.78,1.78,0,0,0-1.59,0c.11-.49.44-.66,0-.92l-1.39-.8a1.74,1.74,0,0,0-1.6,0l-4.38,2.53a2.3,2.3,0,0,0-1,1.36Z",
    style: {
      opacity: 0.15,
      transformOrigin: "40.985px 258.675px"
    },
    className: "animable",
    id: "elp5t1e5yn86i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.8,256.17a1.14,1.14,0,0,1,.66-.93l8.76-5.06a3.56,3.56,0,0,1,3.18,0l4.29,2.48a1.11,1.11,0,0,1,.66.91c0,.33,0,1.66,0,2a1.11,1.11,0,0,1-.66.92l-8.76,5.06a3.5,3.5,0,0,1-3.18,0l-4.29-2.48a1.13,1.13,0,0,1-.66-.9C31.8,257.82,31.81,256.5,31.8,256.17Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "40.575px 255.869px"
    },
    id: "el81h96ocj39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8,256.17a1.14,1.14,0,0,1,.66-.93l5.88-3.39v10.07a3.31,3.31,0,0,1-1.59-.38l-4.29-2.48a1.13,1.13,0,0,1-.66-.9C31.8,257.82,31.81,256.5,31.8,256.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "35.07px 256.885px"
    },
    id: "el9a0ozoepr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.93,259.56l8.76-5.06a1,1,0,0,0,0-1.84l-4.29-2.48a3.56,3.56,0,0,0-3.18,0l-8.76,5.06a1,1,0,0,0,0,1.84l4.29,2.48A3.56,3.56,0,0,0,39.93,259.56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "40.575px 254.87px"
    },
    id: "el1j20rl75eji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.36 271.08 127.92 217.64 126.41 216.77 33.85 270.21 35.36 271.08",
    style: {
      fill: "#3CB499",
      transformOrigin: "80.885px 243.925px"
    },
    id: "elt9y3wmewyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elf1g4zkhhjs"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "35.36 271.08 127.92 217.64 126.41 216.77 33.85 270.21 35.36 271.08",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "80.885px 243.925px"
    },
    className: "animable",
    id: "ely6e9ff5b7ep"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "35.36 271.08 39.85 297.81 132.41 244.37 127.92 217.64 35.36 271.08",
    style: {
      fill: "#3CB499",
      transformOrigin: "83.885px 257.725px"
    },
    id: "elerri25on5w5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.85 270.21 38.34 296.94 39.85 297.81 35.36 271.08 33.85 270.21",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "36.85px 284.01px"
    },
    id: "elyhb1uh0u9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.85 266.18 39.85 297.81 35.36 271.08 43.85 266.18",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "39.605px 281.995px"
    },
    id: "elhzakjmztqy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.92 249.27 127.92 217.64 132.41 244.37 123.92 249.27",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "128.165px 233.455px"
    },
    id: "elpn94e5gxpoq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.39 288.83 59.39 257.2 50.2 262.5 46.2 294.13 55.39 288.83",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "52.795px 275.665px"
    },
    id: "elnfr9txbnchh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.93 279.86 74.93 248.23 65.74 253.53 61.74 285.16 70.93 279.86",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "68.335px 266.695px"
    },
    id: "elfstbizzf7jt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.48 270.89 90.48 239.26 81.28 244.56 77.28 276.19 86.48 270.89",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "83.88px 257.725px"
    },
    id: "eltlxvx4jkc49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.02 261.92 106.02 230.28 96.83 235.59 92.83 267.22 102.02 261.92",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "99.425px 248.75px"
    },
    id: "elkyqb1z6qun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.56 252.94 121.56 221.31 112.37 226.61 108.37 258.24 117.56 252.94",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "114.965px 239.775px"
    },
    id: "elbm2wqj7r3kt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.2 262.5 48.69 261.64 57.88 256.33 59.39 257.2 50.2 262.5",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "54.04px 259.415px"
    },
    id: "elj22fal7w09n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.74 253.53 64.23 252.66 73.43 247.36 74.93 248.23 65.74 253.53",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "69.58px 250.445px"
    },
    id: "el5g3mmwvn2ic",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.28 244.56 79.78 243.69 88.97 238.39 90.48 239.26 81.28 244.56",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "85.13px 241.475px"
    },
    id: "el27ikkesjm0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.83 235.59 95.32 234.72 104.52 229.41 106.02 230.28 96.83 235.59",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "100.67px 232.5px"
    },
    id: "el3ntvxtzawew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.37 226.61 110.86 225.74 120.06 220.44 121.56 221.31 112.37 226.61",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "116.21px 223.525px"
    },
    id: "elrf2g6yvv0vg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.36 271.08 33.85 270.21 42.34 265.31 43.85 266.18 35.36 271.08",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "38.85px 268.195px"
    },
    id: "elfrbiedjg9yp",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2",
    className: "animable",
    style: {
      transformOrigin: "269.885px 242.566px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-2",
    className: "animable",
    style: {
      transformOrigin: "269.885px 242.566px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.91,359.52c0,3.56,2.67,8,6,9.88L229.2,449.85a13.13,13.13,0,0,0,11.9,0L458.45,324.37c3.28-1.9,5.95-6.33,5.95-9.89s-2.67-8-5.95-9.88L319.12,224.15a13.16,13.16,0,0,0-11.91,0L89.87,349.63C86.58,351.53,83.91,356,83.91,359.52Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "274.155px 337.001px"
    },
    id: "elga8enxz1mkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.87,356.51,229.2,437a13.13,13.13,0,0,0,11.9,0L458.45,311.47c3.28-1.9,3.28-5,0-6.87L319.12,224.15a13.16,13.16,0,0,0-11.91,0L89.87,349.63C86.58,351.53,86.58,354.61,89.87,356.51Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "274.156px 330.576px"
    },
    id: "elavxiyichfgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.15,438.39v12.88a12.12,12.12,0,0,1-6-1.42L89.86,369.4c-3.28-1.89-6-6.32-6-9.88,0-3.34,2.35-7.44,5.35-9.5-2.67,1.91-2.46,4.72.6,6.49L229.2,437A12.12,12.12,0,0,0,235.15,438.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "159.505px 400.647px"
    },
    id: "elh4c4675izrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.57,35.56c-2.79-2.22-7.57-2.2-10.86-.3L81.37,160.74a13.16,13.16,0,0,0-6,10.31V341.26h0c0,3.8,2.36,8,5.69,9.25,3.51,1.35,5.5,1,8.78-.91h0L307.21,224.15a13.14,13.14,0,0,0,6-10.31V43.63C313.16,39.83,312.48,37.88,309.57,35.56Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "194.29px 192.593px"
    },
    id: "elr5j09t1vato",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.17,43.62c0-3.79-2.67-5.32-6-3.43L89.86,165.68a12.11,12.11,0,0,0-4.2,4.45l-8.5-4.94h0a12.24,12.24,0,0,1,4.22-4.45L298.71,35.26c3.28-1.9,8.08-1.94,10.85.3C312.49,37.92,313.17,39.83,313.17,43.62Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "195.165px 101.993px"
    },
    id: "el5h31t35yxeb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.94,346.18l0-170.2a12.13,12.13,0,0,1,1.75-5.86h0l-8.5-4.92A12.08,12.08,0,0,0,75.42,171V341.28c0,3.8,2.37,8,5.69,9.25,3.51,1.35,5.51,1,8.79-.91C86.61,351.52,83.94,350,83.94,346.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "82.66px 258.272px"
    },
    id: "elgpk4mnshcl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.07,172.54,302.23,51.81c2-1.13,3.57-.21,3.57,2.07V212.17a7.9,7.9,0,0,1-3.57,6.19L93.07,339.08c-2,1.14-3.57.22-3.57-2.06V178.73A7.9,7.9,0,0,1,93.07,172.54Z",
    id: "elnfy0es687c",
    className: "animable",
    style: {
      transformOrigin: "197.65px 195.448px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.07,172.54a7.9,7.9,0,0,0-3.57,6.19V334.26L296.27,214.92a7.9,7.9,0,0,0,3.57-6.19V53.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "194.67px 193.725px"
    },
    id: "elu7q5d61ckp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25,350.64,308,235.33a6.23,6.23,0,0,1,5.61,0l7.28,4.08c1.55.9,1.55,2.35,0,3.24L121.11,358a6.25,6.25,0,0,1-5.62,0l-7.24-4.06C106.7,353,106.7,351.54,108.25,350.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "214.57px 296.665px"
    },
    id: "elir14pclvdvh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.86,362.21,327.59,246.9a5.71,5.71,0,0,1,5.13-.28l52,30c1.28.74,1.06,2.06-.49,3L184.73,394.75a5.74,5.74,0,0,1-5.14.29l-52.2-29.87C126.1,364.43,126.31,363.11,127.86,362.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "256.049px 320.827px"
    },
    id: "elvsw92d20sii",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.93,295.33l6.26-3.61c.26-.15.29-.39.05-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.62c-.27.15-.29.38-.06.52l6,3.45A1,1,0,0,0,300.93,295.33Zm-9.13-12.49-6.25,3.61c-.27.15-.29.39-.05.53l6,3.45a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.05-.53l-6-3.45A1,1,0,0,0,291.8,282.84Zm-20.2,11.67L261,300.62c-.27.15-.29.38-.06.52l6,3.45a1,1,0,0,0,.91,0l10.59-6.11c.26-.15.29-.39.05-.52l-6-3.46A1,1,0,0,0,271.6,294.51Zm11.06-6.39-6.25,3.61c-.27.15-.29.39-.05.52l6,3.46a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.05-.53l-6-3.45A1,1,0,0,0,282.66,288.12Zm-24.53,14.16-6.25,3.61c-.27.16-.29.39-.06.53l6,3.45a1,1,0,0,0,.9,0l6.26-3.61c.26-.15.29-.39,0-.53l-6-3.45A1,1,0,0,0,258.13,302.28ZM249,307.56l-6.25,3.61c-.27.15-.29.39-.06.52l6,3.46a1,1,0,0,0,.9,0l6.26-3.61c.26-.16.29-.39,0-.53l-6-3.45A1,1,0,0,0,249,307.56Zm23.45,14.09,6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46a1,1,0,0,0-.9,0l-6.26,3.62c-.26.15-.29.38-.05.52l6,3.45A1,1,0,0,0,272.44,321.65Zm-9.14,5.28,6.25-3.61c.27-.15.29-.39.06-.53l-6-3.45a1,1,0,0,0-.9,0L256.46,323c-.26.16-.29.39,0,.53l6,3.45A1,1,0,0,0,263.3,326.93Zm-9.14,5.28,6.25-3.61c.27-.16.29-.39.06-.53l-6-3.45a1,1,0,0,0-.9,0l-6.26,3.61c-.26.15-.29.39,0,.52l6,3.46A1,1,0,0,0,254.16,332.21ZM245,337.48l6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46a1,1,0,0,0-.9,0l-6.26,3.61c-.26.15-.29.38-.05.52l6,3.45A1,1,0,0,0,245,337.48Zm46.77-36.87,6.26-3.61c.26-.15.29-.39.05-.52l-6-3.46a1,1,0,0,0-.91,0L285,296.66c-.27.16-.29.39-.06.53l6,3.45A1,1,0,0,0,291.79,300.61Zm-10.21,15.77,13.95-8.06c.27-.15.29-.39.05-.52l-14.53-8.39a1,1,0,0,0-.9,0l-7.22,4.17c-.27.15-.29.38-.05.52l7.69,4.44c.23.14.21.37-.06.53l-5.77,3.33c-.26.15-.29.39-.05.52l6,3.46A1,1,0,0,0,281.58,316.38Zm-41.73-3.54-6.25,3.61c-.27.15-.29.38-.06.52l6,3.45a1,1,0,0,0,.9,0l6.26-3.61c.26-.15.29-.39.05-.52l-6-3.46A1,1,0,0,0,239.85,312.84Zm-9.14,5.27-6.25,3.61c-.27.16-.29.39-.06.53l6,3.45a1,1,0,0,0,.9,0l6.26-3.61c.26-.15.29-.39,0-.52l-6-3.46A1,1,0,0,0,230.71,318.11Zm-50.58,56.34a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46a1,1,0,0,0-.91,0l-6.26,3.61c-.26.16-.29.39,0,.53Zm-22.54-14.12-6.25,3.61c-.27.15-.29.39-.06.52l6,3.46a1,1,0,0,0,.91,0l6.25-3.62c.26-.15.29-.38,0-.52l-6-3.45A1,1,0,0,0,157.59,360.33Zm11.59,10.58a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.06-.53l-6-3.45a1,1,0,0,0-.9,0l-6.26,3.61c-.26.15-.29.39-.05.52Zm25.22,5.67,6.25-3.61c.27-.16.29-.39.06-.53l-6-3.45a1,1,0,0,0-.91,0l-6.25,3.61c-.26.15-.29.39-.05.53l6,3.45A1,1,0,0,0,194.4,376.58Zm-10.05,5.31a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.06-.53l-6-3.45a1,1,0,0,0-.91,0l-6.25,3.61c-.26.15-.29.39,0,.52Zm-17.62-26.84-6.25,3.61c-.27.15-.29.39-.06.53l6,3.45a1,1,0,0,0,.9,0l6.26-3.61c.26-.16.29-.39.05-.53l-6-3.45A1,1,0,0,0,166.73,355.05Zm45.7-26.38-6.25,3.61c-.27.15-.29.38-.06.52l6,3.46a1,1,0,0,0,.9,0l6.26-3.61c.26-.15.29-.38,0-.52l-6-3.45A1,1,0,0,0,212.43,328.67Zm-36.56,21.1-6.25,3.61c-.27.16-.29.39-.06.53l6,3.45a1,1,0,0,0,.9,0l6.26-3.61c.26-.15.29-.39,0-.52l-6-3.46A1,1,0,0,0,175.87,349.77Zm45.7-26.38L215.32,327c-.27.15-.29.39-.06.52l6,3.46a1,1,0,0,0,.9,0l6.26-3.61c.26-.16.29-.39.05-.53l-6-3.45A1,1,0,0,0,221.57,323.39Zm-18.28,10.55L197,337.55c-.27.16-.29.39-.06.53l6,3.45a1,1,0,0,0,.9,0l6.26-3.61c.26-.15.29-.39.05-.52l-6-3.46A1,1,0,0,0,203.29,333.94Zm-9.14,5.28-6.25,3.61c-.27.15-.29.39-.06.52l6,3.46a1,1,0,0,0,.9,0l6.26-3.61c.26-.16.29-.39,0-.53l-6-3.45A1,1,0,0,0,194.15,339.22ZM185,344.5l-6.25,3.61c-.27.15-.29.39-.06.52l6,3.46a1,1,0,0,0,.9,0l6.26-3.62c.26-.15.29-.38.05-.52l-6-3.45A1,1,0,0,0,185,344.5ZM226.74,348l6.25-3.61c.27-.16.29-.39.06-.53l-6-3.45a1,1,0,0,0-.9,0l-6.26,3.61c-.26.15-.29.39-.05.52l6,3.46A1,1,0,0,0,226.74,348ZM312,271.18l-6.26,3.61c-.26.15-.29.38-.05.52l6,3.45a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.38.06-.52l-6-3.46A1,1,0,0,0,312,271.18Zm-11.07,6.38-6.25,3.61c-.27.16-.29.39-.05.53l6,3.45a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39.05-.52l-6-3.46A1,1,0,0,0,300.94,277.56Zm20.21-11.66-6.26,3.61c-.26.15-.29.39-.05.52l6,3.46a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.06-.53l-6-3.45A1,1,0,0,0,321.15,265.9Zm-50.52,46.93,6.25-3.61c.27-.15.29-.39.05-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.61c-.27.16-.29.39-.05.53l6,3.45A1,1,0,0,0,270.63,312.83Zm60.56-52.24a1,1,0,0,0-.9,0L324,264.23c-.26.16-.29.39,0,.53l6,3.45a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39.06-.52Zm-95.31,82.17,6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46a1,1,0,0,0-.9,0L229,338.81c-.26.16-.29.39,0,.53l6,3.45A1,1,0,0,0,235.88,342.76ZM348,278.05l6.26-3.61c.26-.15.29-.39,0-.53l-6-3.45a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.39-.06.53l6,3.45A1,1,0,0,0,348,278.05Zm-17.68.34,6.25-3.61c.27-.15.29-.39.05-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.61c-.27.16-.29.39-.05.53l6,3.45A1,1,0,0,0,330.28,278.39Zm9.46-12.86a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.39-.05.52l6,3.46a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.38.05-.52Zm1.93-1.12,14.52,8.39a1,1,0,0,0,.91,0l6.26-3.61c.26-.15.29-.39.05-.52l-14.53-8.39a1,1,0,0,0-.91,0l-6.25,3.61C341.45,264,341.43,264.28,341.67,264.41Zm-21.12,11.7-6.25,3.61c-.27.15-.29.39-.05.53l6,3.45a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.05-.53l-6-3.45A1,1,0,0,0,320.55,276.11Zm-68.79,39.72-6.25,3.61c-.27.15-.29.38,0,.52l6,3.45a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.38,0-.52l-6-3.46A1,1,0,0,0,251.76,315.83Zm86.16-32.47a1,1,0,0,0,.9,0l6.26-3.61c.26-.16.29-.39.05-.53l-6-3.45a1,1,0,0,0-.91,0L332,279.38c-.27.15-.29.39-.06.52Zm-77,27.19-6.25,3.61c-.27.15-.29.39-.05.52l6,3.46a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.05-.53l-6-3.45A1,1,0,0,0,260.9,310.55Zm-71.63,58.63a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.38.06-.52l-6-3.45a1,1,0,0,0-.91,0l-6.26,3.61c-.26.15-.29.39-.05.52ZM178.65,358l-6.26,3.61c-.26.15-.29.39,0,.53l6,3.45a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39.06-.53l-6-3.45A1,1,0,0,0,178.65,358Zm20.67,5.83,6.25-3.61c.27-.16.29-.39.06-.53l-6-3.45a1,1,0,0,0-.91,0l-6.26,3.61c-.26.15-.29.39,0,.52l6,3.46A1,1,0,0,0,199.32,363.87Zm9.14-5.28,6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46a1,1,0,0,0-.9,0l-6.26,3.61c-.26.16-.29.39-.05.53l6,3.45A1,1,0,0,0,208.46,358.59Zm9.14-5.28,6.25-3.61c.27-.15.29-.38.06-.52l-6-3.45a1,1,0,0,0-.9,0l-6.26,3.61c-.26.15-.29.39,0,.52l6,3.46A1,1,0,0,0,217.6,353.31Zm-29.82-.55-6.25,3.61c-.26.16-.29.39-.05.53l6,3.45a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46A1,1,0,0,0,187.78,352.76Zm9.14-5.27-6.25,3.61c-.26.15-.29.39,0,.52l6,3.46a1,1,0,0,0,.91,0l6.25-3.62c.27-.15.29-.38.06-.52l-6-3.45A1,1,0,0,0,196.92,347.49Zm36.56-21.11L227.23,330c-.27.15-.29.39,0,.52l6,3.46a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.06-.53l-6-3.45A1,1,0,0,0,233.48,326.38Zm-9.14,5.28-6.25,3.61c-.26.15-.29.39-.05.52l6,3.46a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.38.06-.52l-6-3.45A1,1,0,0,0,224.34,331.66Zm18.28-10.56-6.25,3.61c-.27.16-.29.39-.05.53l6,3.45a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39,0-.52l-6-3.46A1,1,0,0,0,242.62,321.1Zm-36.56,21.11-6.25,3.61c-.26.15-.29.39-.05.53l6,3.45a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.06-.53l-6-3.45A1,1,0,0,0,206.06,342.21Zm9.14-5.28L209,340.54c-.26.16-.29.39,0,.53l6,3.45a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46A1,1,0,0,0,215.2,336.93ZM203.54,371.3l6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.61c-.27.16-.29.39,0,.53l6,3.45A1,1,0,0,0,203.54,371.3ZM155.34,369l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.62c-.27.15-.29.38-.06.52l6,3.45a1,1,0,0,0,.91,0l6.25-3.61C155.55,369.4,155.58,369.16,155.34,369Zm11.92,3-6-3.46a1,1,0,0,0-.9,0l-9.63,5.56c-.26.15-.29.39-.05.52l6,3.46a1,1,0,0,0,.91,0l9.62-5.56C167.47,372.39,167.49,372.15,167.26,372Zm-20.85-9.81-6-3.46a1,1,0,0,0-.91,0l-7.7,4.45c-.26.15-.29.38,0,.52l6,3.45a1,1,0,0,0,.91,0l7.7-4.44C146.62,362.58,146.65,362.34,146.41,362.21Zm5.9-3.41a1,1,0,0,0,.91,0l6.26-3.61c.26-.16.29-.39.05-.53l-6-3.45a1,1,0,0,0-.91,0l-6.26,3.61c-.26.15-.29.39,0,.52Zm25.9,16.76-6-3.45a1,1,0,0,0-.91,0l-12,6.94c-.26.16-.29.39,0,.53l6,3.45a1,1,0,0,0,.91,0l12-6.94C178.42,375.93,178.44,375.7,178.21,375.56Zm4.22,7.44-6-3.46a1,1,0,0,0-.91,0L167.84,384c-.27.15-.29.39-.06.52l6,3.46a1,1,0,0,0,.91,0l7.69-4.45C182.64,383.37,182.66,383.13,182.43,383Zm37.84-63.44a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39,0-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.38-.05.52ZM202,330.12a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39,0-.53l-6-3.45a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.39-.05.52Zm-40.54,23.4a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46a1,1,0,0,0-.91,0l-6.26,3.61c-.26.16-.29.39-.05.53Zm49.68-28.68a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39.05-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.61c-.27.16-.29.39,0,.53ZM192.85,335.4a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.38.05-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.39,0,.52Zm-5.94,48a1,1,0,0,0-.9,0L176.38,389c-.26.16-.28.39,0,.53l6,3.45a1,1,0,0,0,.91,0l9.62-5.55c.27-.16.29-.39.06-.53ZM179.73,343a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.06-.53l-6-3.45a1,1,0,0,0-.91,0L173.8,339c-.26.15-.29.39-.05.52Zm-9.14,5.27a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.38.06-.52l-6-3.46a1,1,0,0,0-.91,0l-6.26,3.61c-.26.15-.29.38,0,.52Zm185.65-62.63a1,1,0,0,0-.91,0l-15.39,8.88c-.27.16-.29.39-.05.53l6,3.45a1,1,0,0,0,.91,0l15.39-8.89c.27-.15.29-.38.05-.52ZM336,297.27a1,1,0,0,0-.91,0l-6.25,3.61c-.27.16-.29.39-.06.53l6,3.45a1,1,0,0,0,.91,0l6.26-3.61c.26-.15.29-.39,0-.53ZM212.68,366l6.25-3.62c.27-.15.29-.38.06-.52l-6-3.45a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.39-.05.52l6,3.46A1,1,0,0,0,212.68,366Zm105.08-58.21a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.38-.06.52l6,3.45a1,1,0,0,0,.91,0l6.26-3.61c.26-.15.29-.39.05-.52Zm47.62-27.49a1,1,0,0,0-.91,0L358.22,284c-.27.15-.29.39-.05.52l6,3.46a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.05-.53Zm15.12-1.82L366,270.12a1,1,0,0,0-.9,0l-6.26,3.61c-.26.15-.29.39-.05.52l14.53,8.39a1,1,0,0,0,.91,0l6.25-3.61C380.72,278.88,380.74,278.64,380.5,278.51Zm-96.9,49a1,1,0,0,0-.9,0L275,332c-.27.15-.29.39-.05.52l6,3.46a1,1,0,0,0,.91,0l7.69-4.45c.27-.15.29-.39.06-.52Zm23.09-13.33a1,1,0,0,0-.9,0l-9.62,5.56c-.27.15-.29.39-.06.52l6,3.46a1,1,0,0,0,.91,0l9.62-5.56c.27-.15.29-.39.06-.52Zm-44.25,25.55a1,1,0,0,0-.91,0l-51.47,29.72c-.27.16-.29.39-.06.53l6,3.45a1,1,0,0,0,.91,0l51.47-29.72c.26-.15.29-.39.05-.52Zm-54.36,31.39a1,1,0,0,0-.91,0l-7.7,4.44c-.26.15-.29.39-.05.53l6,3.45a1,1,0,0,0,.91,0l7.7-4.44c.26-.16.29-.39.05-.53ZM273,333.65a1,1,0,0,0-.91,0l-7.69,4.45c-.27.15-.29.39-.06.52l6,3.46a1,1,0,0,0,.9,0l7.7-4.45c.27-.15.29-.39.05-.52ZM197.5,377.26a1,1,0,0,0-.91,0l-7.7,4.44c-.26.16-.29.39,0,.53l6,3.45a1,1,0,0,0,.91,0l7.7-4.44c.26-.16.29-.39,0-.53Zm96.69-55.83a1,1,0,0,0-.91,0l-7.7,4.45c-.26.15-.29.39-.05.52l6,3.46a1,1,0,0,0,.91,0l7.7-4.45c.26-.15.29-.39.05-.52Zm32.71-18.88a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.39-.06.52l6,3.46a1,1,0,0,0,.9,0l6.26-3.61c.26-.16.29-.39.05-.53Zm20.47-14.29,6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46a1,1,0,0,0-.9,0l-6.26,3.61c-.26.16-.29.39,0,.53l6,3.45A1,1,0,0,0,347.37,288.26Zm-37.3,1.8,6.26-3.61c.26-.16.29-.39.05-.53l-6-3.45a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.39-.06.52l6,3.46A1,1,0,0,0,310.07,290.06ZM285.8,323.81l18.28-10.55c.26-.16.29-.39.05-.53l-6-3.45a1,1,0,0,0-.91,0L279,319.86c-.27.16-.29.39,0,.53l6,3.45A1,1,0,0,0,285.8,323.81Zm51.52-30.24a1,1,0,0,0,.91,0l6.25-3.61c.27-.16.29-.39.06-.53l-6-3.45a1,1,0,0,0-.9,0l-6.26,3.61c-.26.15-.29.39-.05.52Zm-7.64-5,6.26-3.61c.26-.15.29-.39.05-.52L330,281a1,1,0,0,0-.91,0l-6.25,3.62c-.27.15-.29.38-.06.52l6,3.45A1,1,0,0,0,329.68,288.6Zm-53,40.49,6.25-3.61c.27-.16.29-.39,0-.53l-6-3.45a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.39-.05.52l6,3.46A1,1,0,0,0,276.66,329.09Zm40.46-23.86a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39.05-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.61c-.27.16-.29.39-.05.53ZM231,355.47l6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.61c-.27.16-.29.39-.05.53l6,3.45A1,1,0,0,0,231,355.47Zm9.14-5.28,6.25-3.61c.27-.15.29-.38.05-.52l-6-3.45a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.39,0,.52l6,3.46A1,1,0,0,0,240.1,350.19Zm-18.28,10.56,6.25-3.61c.27-.16.29-.39.05-.53l-6-3.45a1,1,0,0,0-.91,0L215,356.8c-.27.15-.29.39,0,.53l6,3.45A1,1,0,0,0,221.82,360.75Zm36.56-21.11,6.25-3.61c.27-.15.29-.39.05-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.61c-.27.16-.29.39,0,.53l6,3.45A1,1,0,0,0,258.38,339.64Zm-9.14,5.28,6.25-3.61c.27-.16.29-.39,0-.53l-6-3.45a1,1,0,0,0-.91,0L242.4,341c-.27.15-.29.39-.05.52l6,3.46A1,1,0,0,0,249.24,344.92Zm18.28-10.56,6.25-3.61c.27-.15.29-.39.05-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.38-.05.52l6,3.46A1,1,0,0,0,267.52,334.36ZM317.39,261a1,1,0,0,0,.91,0l6.26-3.61c.26-.15.28-.38.05-.52l-1.59-.92a1,1,0,0,0-.91,0l-6.26,3.61c-.26.15-.28.39-.05.53ZM272,289.72a1,1,0,0,0,.9,0l6.26-3.61c.26-.16.29-.39.05-.53l-6-3.45a1,1,0,0,0-.91,0L266,285.74c-.27.15-.29.39-.06.52Zm18.28-10.56a1,1,0,0,0,.9,0l6.26-3.61c.26-.15.29-.39,0-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.62c-.27.15-.29.38-.06.52Zm-29.45,17a1,1,0,0,0,.91,0l6.26-3.61c.26-.15.29-.39,0-.53l-6-3.45a1,1,0,0,0-.91,0l-6.25,3.61c-.27.16-.29.39-.06.53Zm20.31-11.72a1,1,0,0,0,.9,0l6.26-3.61c.26-.15.29-.39.05-.53l-6-3.45a1,1,0,0,0-.91,0l-6.25,3.61c-.27.16-.29.39-.06.53Zm-38.59,22.28a1,1,0,0,0,.91,0l6.26-3.61c.26-.15.29-.38.05-.52l-6-3.46a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.38-.06.52Zm9.14-5.28a1,1,0,0,0,.91,0l6.26-3.61c.26-.16.29-.39.05-.53l-6-3.45a1,1,0,0,0-.91,0l-6.25,3.61c-.27.15-.29.39-.06.52Zm47.45-29.93a1,1,0,0,0,.91,0l6.26-3.61c.26-.16.29-.39.05-.53l-1.59-.92a1,1,0,0,0-.91,0l-6.25,3.62c-.27.15-.3.38-.06.52Zm27.42-15.83a1,1,0,0,0,.91,0L333.7,252c.26-.16.29-.39.05-.53l-1.59-.92a1,1,0,0,0-.91,0L325,254.23c-.26.16-.29.39-.05.53Zm12.57,7.25a1,1,0,0,0,.91,0l6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46a1,1,0,0,0-.9,0L333.17,259c-.26.15-.29.38-.05.52ZM356.51,283l6.25-3.61c.27-.15.29-.39.06-.52l-6-3.46a1,1,0,0,0-.9,0L349.67,279c-.26.15-.29.38-.05.52l6,3.45A1,1,0,0,0,356.51,283Zm-48.26-16.75a1,1,0,0,0,.91,0l6.26-3.61c.26-.15.29-.39.05-.52l-1.59-.92a1,1,0,0,0-.91,0l-6.26,3.61c-.26.15-.29.39,0,.52ZM233.39,312a1,1,0,0,0,.9,0l6.26-3.61c.26-.15.29-.39,0-.52l-6-3.46a1,1,0,0,0-.91,0L227.46,308c-.27.16-.29.39-.06.53Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "256.132px 321.765px"
    },
    id: "eluchkuxm5xzm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.56 364 260.92 364.79 297.04 385.64 361.27 348.55 362.61 347.79 325.13 326.16 259.56 364",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "311.085px 355.9px"
    },
    id: "elzzpkqg3iaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.44 349.03 325.13 328.65 261.75 365.26 297.04 385.64 360.44 349.03",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "311.095px 357.145px"
    },
    id: "elx5fqu0wg13b",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears-1--inject-2",
    className: "animable",
    style: {
      transformOrigin: "197.93px 208.702px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-2",
    className: "animable",
    style: {
      transformOrigin: "197.93px 208.702px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-2",
    className: "animable",
    style: {
      transformOrigin: "253.24px 184.032px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.41,210.33a2.43,2.43,0,0,1,3-.19l3.43,2.57a1.94,1.94,0,0,0,2.76-.41l6.61-9.11a3.12,3.12,0,0,0,.09-3.29l-2.65-4.1a3.93,3.93,0,0,1-.18-3.46c.84-1.76,1.61-3.56,2.27-5.38a5.73,5.73,0,0,1,2.44-2.77l6.47-3.21a4.25,4.25,0,0,0,2.07-2.86l1.37-9.55a1.31,1.31,0,0,0-.53-1.37h0l-.09-.05h0l-7.92-4.57h0a1.53,1.53,0,0,0-1.1-.12l-.74.17a4.76,4.76,0,0,1,.57-2.51l5.48-8.66a2.75,2.75,0,0,0-.28-3.15L284,144.47a1.64,1.64,0,0,0-.49-.35v0l-8-4.62h0a1.68,1.68,0,0,0-2.12.45l-5.14,6.19.2-3.45a1.27,1.27,0,0,0-.57-1.26h0l-8-4.63h0a1.4,1.4,0,0,0-1.16,0l-7,2.57a4.06,4.06,0,0,0-2.31,2.63l-2,8.91a6.19,6.19,0,0,1-2.06,3.09,48.49,48.49,0,0,0-3.83,3.18,2.34,2.34,0,0,1-1.27.59l-5.4-3.12h0a1.94,1.94,0,0,0-2.53.55l-6.61,9.11a3.12,3.12,0,0,0-.09,3.29l2.65,4.1a3.93,3.93,0,0,1,.18,3.46c-.84,1.76-1.61,3.56-2.27,5.38a5.73,5.73,0,0,1-2.44,2.77l-6.47,3.21a4.25,4.25,0,0,0-2.07,2.86l-1.37,9.55a1.29,1.29,0,0,0,.57,1.4h0l8,4.61h0a1.51,1.51,0,0,0,1.09.11l.74-.17a4.76,4.76,0,0,1-.57,2.51L218.17,216a2.75,2.75,0,0,0,.28,3.15L222,223a1.62,1.62,0,0,0,.44.35h0l8,4.6v0a1.65,1.65,0,0,0,2.19-.38l5.14-6.19-.2,3.45a1.27,1.27,0,0,0,.58,1.27h0l8,4.6h0a1.41,1.41,0,0,0,1.2.05l7-2.58a4,4,0,0,0,2.31-2.63l2-8.91a6.19,6.19,0,0,1,2.06-3.09A46.4,46.4,0,0,0,264.41,210.33Zm-1.51-43.77a16.59,16.59,0,0,1,1,9.38c-1.49,10.36-9.36,21.2-17.58,24.23a12.32,12.32,0,0,1-3.23.77,16.58,16.58,0,0,1-1-9.41c1.49-10.35,9.36-21.2,17.58-24.23A12.51,12.51,0,0,1,262.9,166.56Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "252.958px 183.767px"
    },
    id: "el4cpz3c40luh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqu0ap86rna"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.41,210.33a2.43,2.43,0,0,1,3-.19l3.43,2.57a1.94,1.94,0,0,0,2.76-.41l6.61-9.11a3.12,3.12,0,0,0,.09-3.29l-2.65-4.1a3.93,3.93,0,0,1-.18-3.46c.84-1.76,1.61-3.56,2.27-5.38a5.73,5.73,0,0,1,2.44-2.77l6.47-3.21a4.25,4.25,0,0,0,2.07-2.86l1.37-9.55a1.31,1.31,0,0,0-.53-1.37h0l-.09-.05h0l-7.92-4.57h0a1.53,1.53,0,0,0-1.1-.12l-.74.17a4.76,4.76,0,0,1,.57-2.51l5.48-8.66a2.75,2.75,0,0,0-.28-3.15L284,144.47a1.64,1.64,0,0,0-.49-.35v0l-8-4.62h0a1.68,1.68,0,0,0-2.12.45l-5.14,6.19.2-3.45a1.27,1.27,0,0,0-.57-1.26h0l-8-4.63h0a1.4,1.4,0,0,0-1.16,0l-7,2.57a4.06,4.06,0,0,0-2.31,2.63l-2,8.91a6.19,6.19,0,0,1-2.06,3.09,48.49,48.49,0,0,0-3.83,3.18,2.34,2.34,0,0,1-1.27.59l-5.4-3.12h0a1.94,1.94,0,0,0-2.53.55l-6.61,9.11a3.12,3.12,0,0,0-.09,3.29l2.65,4.1a3.93,3.93,0,0,1,.18,3.46c-.84,1.76-1.61,3.56-2.27,5.38a5.73,5.73,0,0,1-2.44,2.77l-6.47,3.21a4.25,4.25,0,0,0-2.07,2.86l-1.37,9.55a1.29,1.29,0,0,0,.57,1.4h0l8,4.61h0a1.51,1.51,0,0,0,1.09.11l.74-.17a4.76,4.76,0,0,1-.57,2.51L218.17,216a2.75,2.75,0,0,0,.28,3.15L222,223a1.62,1.62,0,0,0,.44.35h0l8,4.6v0a1.65,1.65,0,0,0,2.19-.38l5.14-6.19-.2,3.45a1.27,1.27,0,0,0,.58,1.27h0l8,4.6h0a1.41,1.41,0,0,0,1.2.05l7-2.58a4,4,0,0,0,2.31-2.63l2-8.91a6.19,6.19,0,0,1,2.06-3.09A46.4,46.4,0,0,0,264.41,210.33Zm-1.51-43.77a16.59,16.59,0,0,1,1,9.38c-1.49,10.36-9.36,21.2-17.58,24.23a12.32,12.32,0,0,1-3.23.77,16.58,16.58,0,0,1-1-9.41c1.49-10.35,9.36-21.2,17.58-24.23A12.51,12.51,0,0,1,262.9,166.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "252.958px 183.767px"
    },
    className: "animable",
    id: "elc1x6w3z5726"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely3d1c1eh92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.89,153.06a3.35,3.35,0,0,0,3.16-.92l6.31-7.6a1.68,1.68,0,0,1,2-.49l-7.9-4.57a1.7,1.7,0,0,0-2.12.44l-5.14,6.19-.27,4.58a1.94,1.94,0,0,0,1.88,2A13.16,13.16,0,0,1,271.89,153.06Zm11.69,9.5h0a1.53,1.53,0,0,0-1.09-.13l-.74.18a3.89,3.89,0,0,0,.14,1.06,21.08,21.08,0,0,1,.66,3.22,1.73,1.73,0,0,0,2.15,1.52l5.77-1.36a1.41,1.41,0,0,1,1.09.12Z",
    style: {
      opacity: 0.1,
      transformOrigin: "279.745px 153.873px"
    },
    className: "animable",
    id: "elfqj02eys4gb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcawh82wcth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.85,180.56c1.28-8.94-2.59-14.58-9-14a16.58,16.58,0,0,1,1,9.38c-1.49,10.36-9.35,21.21-17.58,24.24a12.56,12.56,0,0,1-3.22.75c1.92,4.11,6,5.78,11.2,3.86C262.5,201.76,270.36,190.91,271.85,180.56Z",
    style: {
      opacity: 0.1,
      transformOrigin: "257.572px 186.051px"
    },
    className: "animable",
    id: "elljyeri9tkia"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.73,177.63a3.34,3.34,0,0,0-.47-1.34l-2.65-4.11a3.12,3.12,0,0,1-.37-2.12l-8-4.61a3,3,0,0,0,.37,2.11l2.65,4.12a3.47,3.47,0,0,1,.44,1.35Zm-14.34,27.29h0a1.3,1.3,0,0,1-.58-1.4l1.37-9.54a4.05,4.05,0,0,1,1.09-2.08l-8-4.62a4.13,4.13,0,0,0-1.09,2.08l-1.37,9.56a1.29,1.29,0,0,0,.56,1.39Zm33.06-49.54,2-8.8a3.89,3.89,0,0,1,1.11-1.86l-8-4.61a4,4,0,0,0-1.14,1.85l-2,8.81ZM230.37,228a4.32,4.32,0,0,1-.42-.35l-3.52-3.81a2.75,2.75,0,0,1-.28-3.15l5.47-8.66a3.89,3.89,0,0,0,.52-1.55l-8-4.61a4.18,4.18,0,0,1-.52,1.55L218.17,216a2.76,2.76,0,0,0,.28,3.15L222,223a1.48,1.48,0,0,0,.44.36ZM246,230.69a1,1,0,0,1-.24-.23,1,1,0,0,1-.26-.5,1.93,1.93,0,0,1,0-.55l.46-8a1.3,1.3,0,0,0-.05-.53,1.67,1.67,0,0,0-.41-.79,1.86,1.86,0,0,0-.57-.46l-.33-.14a4.64,4.64,0,0,0-.51-.11,13.36,13.36,0,0,1-2-.32,3.35,3.35,0,0,0-3.18.91l-1.16,1.41-.21,3.45a1.3,1.3,0,0,0,.59,1.27h0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "236.167px 185.4px"
    },
    id: "elqb0opht1fq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwave0drlqka"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.73,177.63a3.34,3.34,0,0,0-.47-1.34l-2.65-4.11a3.12,3.12,0,0,1-.37-2.12l-8-4.61a3,3,0,0,0,.37,2.11l2.65,4.12a3.47,3.47,0,0,1,.44,1.35Zm-14.34,27.29h0a1.3,1.3,0,0,1-.58-1.4l1.37-9.54a4.05,4.05,0,0,1,1.09-2.08l-8-4.62a4.13,4.13,0,0,0-1.09,2.08l-1.37,9.56a1.29,1.29,0,0,0,.56,1.39Zm33.06-49.54,2-8.8a3.89,3.89,0,0,1,1.11-1.86l-8-4.61a4,4,0,0,0-1.14,1.85l-2,8.81ZM230.37,228a4.32,4.32,0,0,1-.42-.35l-3.52-3.81a2.75,2.75,0,0,1-.28-3.15l5.47-8.66a3.89,3.89,0,0,0,.52-1.55l-8-4.61a4.18,4.18,0,0,1-.52,1.55L218.17,216a2.76,2.76,0,0,0,.28,3.15L222,223a1.48,1.48,0,0,0,.44.36ZM246,230.69a1,1,0,0,1-.24-.23,1,1,0,0,1-.26-.5,1.93,1.93,0,0,1,0-.55l.46-8a1.3,1.3,0,0,0-.05-.53,1.67,1.67,0,0,0-.41-.79,1.86,1.86,0,0,0-.57-.46l-.33-.14a4.64,4.64,0,0,0-.51-.11,13.36,13.36,0,0,1-2-.32,3.35,3.35,0,0,0-3.18.91l-1.16,1.41-.21,3.45a1.3,1.3,0,0,0,.59,1.27h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "236.167px 185.4px"
    },
    className: "animable",
    id: "elsag3xyfa07d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.53,225.51l2-8.91a6.19,6.19,0,0,1,2.06-3.09,44.8,44.8,0,0,0,3.83-3.18,2.43,2.43,0,0,1,3-.19l3.43,2.57a1.94,1.94,0,0,0,2.76-.41l6.61-9.11a3.12,3.12,0,0,0,.09-3.29l-2.65-4.1a3.93,3.93,0,0,1-.18-3.46c.84-1.76,1.61-3.56,2.27-5.38a5.73,5.73,0,0,1,2.44-2.77l6.47-3.21a4.25,4.25,0,0,0,2.07-2.86l1.37-9.55a1.26,1.26,0,0,0-1.65-1.52l-5.78,1.36a1.72,1.72,0,0,1-2.14-1.53,25.26,25.26,0,0,0-.67-3.21,5,5,0,0,1,.43-3.57l5.48-8.66a2.75,2.75,0,0,0-.28-3.15L284,144.47a1.69,1.69,0,0,0-2.62.07l-6.31,7.6a3.36,3.36,0,0,1-3.16.92,15,15,0,0,0-2-.34,2,2,0,0,1-1.88-2l.47-8a1.2,1.2,0,0,0-1.75-1.3l-7,2.57a4.08,4.08,0,0,0-2.3,2.63l-2,8.91a6,6,0,0,1-2.06,3.09,46.63,46.63,0,0,0-3.82,3.18,2.44,2.44,0,0,1-3,.19l-3.43-2.57a2,2,0,0,0-2.76.42l-6.61,9.11a3.15,3.15,0,0,0-.09,3.28l2.65,4.1a3.94,3.94,0,0,1,.19,3.46c-.85,1.76-1.61,3.56-2.28,5.38a5.76,5.76,0,0,1-2.43,2.77l-6.48,3.22a4.28,4.28,0,0,0-2.07,2.85l-1.37,9.56a1.27,1.27,0,0,0,1.66,1.51l5.77-1.36a1.74,1.74,0,0,1,2.15,1.53,25.28,25.28,0,0,0,.66,3.21,5,5,0,0,1-.43,3.58l-5.48,8.65a2.75,2.75,0,0,0,.29,3.15l3.51,3.82a1.69,1.69,0,0,0,2.62-.07l6.31-7.59A3.31,3.31,0,0,1,242,219a13.49,13.49,0,0,0,2.05.33,2,2,0,0,1,1.87,2l-.47,8a1.21,1.21,0,0,0,1.75,1.3l7-2.58A4,4,0,0,0,256.53,225.51Zm-2.26-20.72c-8.22,3-13.68-2.91-12.19-13.26s9.36-21.2,17.58-24.23,13.68,2.9,12.19,13.26S262.5,201.76,254.27,204.79Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "256.998px 186.021px"
    },
    id: "elxhq46iml9qr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elygzo18fdg7p"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55,
      transformOrigin: "256.949px 186.043px"
    },
    className: "animable",
    id: "el12jn0fbr59xb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.53,225.51l2-8.91a6.19,6.19,0,0,1,2.06-3.09,44.8,44.8,0,0,0,3.83-3.18,2.43,2.43,0,0,1,3-.19l3.43,2.57a1.94,1.94,0,0,0,2.76-.41l6.61-9.11a3.12,3.12,0,0,0,.09-3.29l-2.65-4.1a3.93,3.93,0,0,1-.18-3.46c.84-1.76,1.61-3.56,2.27-5.38a5.73,5.73,0,0,1,2.44-2.77l6.47-3.21a4.25,4.25,0,0,0,2.07-2.86l1.37-9.55a1.26,1.26,0,0,0-1.65-1.52l-5.78,1.36a1.72,1.72,0,0,1-2.14-1.53,25.26,25.26,0,0,0-.67-3.21,5,5,0,0,1,.43-3.57l5.48-8.66a2.75,2.75,0,0,0-.28-3.15L284,144.47a1.69,1.69,0,0,0-2.62.07l-6.31,7.6a3.36,3.36,0,0,1-3.16.92,15,15,0,0,0-2-.34,2,2,0,0,1-1.88-2l.47-8a1.2,1.2,0,0,0-1.75-1.3l-7,2.57a4.08,4.08,0,0,0-2.3,2.63l-2,8.91a6,6,0,0,1-2.06,3.09,46.63,46.63,0,0,0-3.82,3.18,2.44,2.44,0,0,1-3,.19l-3.43-2.57a2,2,0,0,0-2.76.42l-6.61,9.11a3.15,3.15,0,0,0-.09,3.28l2.65,4.1a3.94,3.94,0,0,1,.19,3.46c-.85,1.76-1.61,3.56-2.28,5.38a5.76,5.76,0,0,1-2.43,2.77l-6.48,3.22a4.28,4.28,0,0,0-2.07,2.85l-1.37,9.56a1.27,1.27,0,0,0,1.66,1.51l5.77-1.36a1.74,1.74,0,0,1,2.15,1.53,25.28,25.28,0,0,0,.66,3.21,5,5,0,0,1-.43,3.58l-5.48,8.65a2.75,2.75,0,0,0,.29,3.15l3.51,3.82a1.69,1.69,0,0,0,2.62-.07l6.31-7.59A3.31,3.31,0,0,1,242,219a13.49,13.49,0,0,0,2.05.33,2,2,0,0,1,1.87,2l-.47,8a1.21,1.21,0,0,0,1.75,1.3l7-2.58A4,4,0,0,0,256.53,225.51Zm-2.26-20.72c-8.22,3-13.68-2.91-12.19-13.26s9.36-21.2,17.58-24.23,13.68,2.9,12.19,13.26S262.5,201.76,254.27,204.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "256.998px 186.021px"
    },
    id: "el7wd6ku3qk98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.64,231.39a1.72,1.72,0,0,1-1-.32,1.9,1.9,0,0,1-.68-1.69l.47-8a1.4,1.4,0,0,0-1.37-1.45,14.78,14.78,0,0,1-2.13-.34,2.74,2.74,0,0,0-2.6.73L233,227.9a2.26,2.26,0,0,1-3.46.09L226,224.17a3.29,3.29,0,0,1-.35-3.82l5.48-8.66a4.44,4.44,0,0,0,.37-3.13,25,25,0,0,1-.68-3.28,1.3,1.3,0,0,0-.53-.91,1.14,1.14,0,0,0-.94-.16l-5.78,1.36a1.81,1.81,0,0,1-2.33-2.13l1.37-9.56a4.82,4.82,0,0,1,2.37-3.27l6.48-3.22a5.2,5.2,0,0,0,2.16-2.46,57.66,57.66,0,0,1,2.3-5.43,3.37,3.37,0,0,0-.16-2.91l-2.64-4.11a3.66,3.66,0,0,1,.1-3.91l6.61-9.11a2.53,2.53,0,0,1,3.55-.54l3.42,2.58a1.9,1.9,0,0,0,2.32-.15,47,47,0,0,1,3.87-3.23,5.56,5.56,0,0,0,1.85-2.76l2-8.91a4.6,4.6,0,0,1,2.66-3l7-2.58a1.76,1.76,0,0,1,2.5,1.86l-.47,8a1.38,1.38,0,0,0,1.37,1.44,13.59,13.59,0,0,1,2.12.35,2.79,2.79,0,0,0,2.61-.74l6.31-7.59a2.23,2.23,0,0,1,3.45-.09l3.51,3.81a3.3,3.3,0,0,1,.35,3.83l-5.47,8.66a4.36,4.36,0,0,0-.37,3.12,25.52,25.52,0,0,1,.68,3.29,1.26,1.26,0,0,0,.52.9,1.14,1.14,0,0,0,.94.16l5.78-1.36a1.82,1.82,0,0,1,2.33,2.14l-1.37,9.55a4.81,4.81,0,0,1-2.37,3.28l-6.48,3.21a5.25,5.25,0,0,0-2.16,2.46c-.66,1.82-1.43,3.65-2.29,5.44a3.37,3.37,0,0,0,.15,2.91l2.65,4.1a3.68,3.68,0,0,1-.11,3.91l-6.61,9.11a2.49,2.49,0,0,1-3.54.54l-3.43-2.57a1.87,1.87,0,0,0-2.31.15,47.25,47.25,0,0,1-3.88,3.22,5.61,5.61,0,0,0-1.85,2.76l-2,8.91a4.65,4.65,0,0,1-2.65,3l-7,2.57A2.31,2.31,0,0,1,246.64,231.39Zm-5.36-13a3.8,3.8,0,0,1,.89.11,14.2,14.2,0,0,0,2,.32,2.5,2.5,0,0,1,2.38,2.61l-.47,8a.66.66,0,0,0,1,.74l7-2.57a3.49,3.49,0,0,0,1.95-2.23l2-8.91a6.8,6.8,0,0,1,2.27-3.42,46.54,46.54,0,0,0,3.78-3.14,3,3,0,0,1,3.74-.22l3.42,2.57a1.39,1.39,0,0,0,2-.3l6.61-9.11a2.57,2.57,0,0,0,.07-2.66l-2.64-4.1a4.5,4.5,0,0,1-.23-4,57.08,57.08,0,0,0,2.26-5.33,6.28,6.28,0,0,1,2.71-3.08l6.48-3.21a3.7,3.7,0,0,0,1.76-2.44l1.37-9.55a.86.86,0,0,0-.19-.77.88.88,0,0,0-.79-.13L284.81,169a2.29,2.29,0,0,1-1.83-.32,2.35,2.35,0,0,1-1-1.67,25.26,25.26,0,0,0-.66-3.14,5.59,5.59,0,0,1,.5-4l5.48-8.66a2.19,2.19,0,0,0-.22-2.47l-3.51-3.82a1.14,1.14,0,0,0-1.79.05l-6.31,7.59a3.86,3.86,0,0,1-3.72,1.11,12.52,12.52,0,0,0-2-.32,2.5,2.5,0,0,1-2.38-2.62l.47-8a.67.67,0,0,0-1-.74l-7,2.57a3.52,3.52,0,0,0-1.95,2.23l-2,8.91a6.67,6.67,0,0,1-2.28,3.42,44.78,44.78,0,0,0-3.77,3.14,3,3,0,0,1-3.74.23l-3.43-2.58a1.41,1.41,0,0,0-1.05-.26,1.39,1.39,0,0,0-.93.56l-6.61,9.11a2.59,2.59,0,0,0-.07,2.66l2.65,4.1a4.5,4.5,0,0,1,.22,4c-.85,1.76-1.61,3.56-2.26,5.33a6.24,6.24,0,0,1-2.71,3.08l-6.47,3.22a3.7,3.7,0,0,0-1.77,2.43l-1.37,9.55a.85.85,0,0,0,.2.78.86.86,0,0,0,.78.12l5.78-1.36a2.27,2.27,0,0,1,1.82.32,2.38,2.38,0,0,1,1,1.67,22.93,22.93,0,0,0,.65,3.14,5.52,5.52,0,0,1-.5,4l-5.48,8.66a2.19,2.19,0,0,0,.23,2.48l3.51,3.81a1.14,1.14,0,0,0,1.78,0l6.31-7.6A3.74,3.74,0,0,1,241.28,218.38Zm8.92-12.25a8.08,8.08,0,0,1-5.2-1.76c-3-2.45-4.3-7.16-3.47-12.92,1.51-10.52,9.56-21.59,17.94-24.68,3.68-1.35,7-1,9.47.94,3,2.46,4.29,7.17,3.47,12.92-1.52,10.52-9.56,21.59-17.94,24.68A12.39,12.39,0,0,1,250.2,206.13Zm13.53-39.06a11.32,11.32,0,0,0-3.88.75c-8,3-15.76,13.63-17.22,23.79-.77,5.36.35,9.7,3.07,11.9,2.1,1.7,5.08,2,8.38.75h0c8-3,15.76-13.63,17.22-23.78.77-5.36-.34-9.7-3.06-11.9A7,7,0,0,0,263.73,167.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "256.949px 186.043px"
    },
    id: "elg4lun0ry0jt",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-2",
    className: "animable",
    style: {
      transformOrigin: "160.518px 211.025px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.84,278.23l13.39-7.73a3.58,3.58,0,0,0,1.59-2.5l1.34-14.89a5,5,0,0,1,1.4-2.78,80.72,80.72,0,0,0,7.43-7.87,2.58,2.58,0,0,1,2.63-.75l8.59,3a2.09,2.09,0,0,0,2.41-.89l9.84-17a2.07,2.07,0,0,0-.43-2.53l-6.89-5.94a2.58,2.58,0,0,1-.67-2.66,80.63,80.63,0,0,0,3.1-10.37,5,5,0,0,1,1.71-2.59l12.23-8.61a3.62,3.62,0,0,0,1.36-2.63V176a1.09,1.09,0,0,0-.47-1h0l-10-5.82h0a1.14,1.14,0,0,0-1.05,0l-6.92,3.12a3,3,0,0,1,.22-1.63l7.94-16a1.8,1.8,0,0,0-.71-2.33l-6.56-3.79h0l-12.07-7a1.8,1.8,0,0,0-2.37.56L175.94,157a3.08,3.08,0,0,1-1.34,1l-.76-7.5a1.12,1.12,0,0,0-.5-.91h0l-10.05-5.84h0a1.09,1.09,0,0,0-1.09.09l-13.39,7.73a3.59,3.59,0,0,0-1.59,2.49l-1.35,14.9a5,5,0,0,1-1.39,2.78,80.72,80.72,0,0,0-7.43,7.87,2.55,2.55,0,0,1-2.63.74l-8.59-3a2.11,2.11,0,0,0-2.42.9l-9.84,17a2.11,2.11,0,0,0,.43,2.54l6.9,5.94a2.56,2.56,0,0,1,.67,2.65,81.11,81.11,0,0,0-3.1,10.37,5,5,0,0,1-1.71,2.6L104.53,228a3.63,3.63,0,0,0-1.37,2.63V246a1.12,1.12,0,0,0,.46,1h0l10.06,5.85h0a1.1,1.1,0,0,0,1,0l6.92-3.12a3,3,0,0,1-.22,1.63l-7.94,16a1.8,1.8,0,0,0,.71,2.33l10,5.8,0,0,8.62,5a1.8,1.8,0,0,0,2.37-.56l9.89-14.88a2.94,2.94,0,0,1,1.34-1l.76,7.5a1.09,1.09,0,0,0,.5.9h0l10,5.84h0A1.08,1.08,0,0,0,158.84,278.23ZM178,185c2.29,2.43,3.58,6.48,3.58,12.12,0,14.42-10.12,32-22.61,39.16-4.58,2.65-8.6,3.78-11.85,3.46-2.63-2.75-4.19-7.07-4.19-12.71,0-14.42,10.13-31.95,22.62-39.16C170.14,185.16,174.41,184.28,178,185Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "160.515px 211.02px"
    },
    id: "elxsp1f9z81h8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3c94w7ribm6"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "160.515px 211.02px"
    },
    className: "animable",
    id: "elqhbd6fc8jb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.84,278.23l13.39-7.73a3.58,3.58,0,0,0,1.59-2.5l1.34-14.89a5,5,0,0,1,1.4-2.78,80.72,80.72,0,0,0,7.43-7.87,2.58,2.58,0,0,1,2.63-.75l8.59,3a2.09,2.09,0,0,0,2.41-.89l9.84-17a2.07,2.07,0,0,0-.43-2.53l-6.89-5.94a2.58,2.58,0,0,1-.67-2.66,80.63,80.63,0,0,0,3.1-10.37,5,5,0,0,1,1.71-2.59l12.23-8.61a3.62,3.62,0,0,0,1.36-2.63V176a1.09,1.09,0,0,0-.47-1h0l-10-5.82h0a1.14,1.14,0,0,0-1.05,0l-6.92,3.12a3,3,0,0,1,.22-1.63l7.94-16a1.8,1.8,0,0,0-.71-2.33l-6.56-3.79h0l-12.07-7a1.8,1.8,0,0,0-2.37.56L175.94,157a3.08,3.08,0,0,1-1.34,1l-.76-7.5a1.12,1.12,0,0,0-.5-.91h0l-10.05-5.84h0a1.09,1.09,0,0,0-1.09.09l-13.39,7.73a3.59,3.59,0,0,0-1.59,2.49l-1.35,14.9a5,5,0,0,1-1.39,2.78,80.72,80.72,0,0,0-7.43,7.87,2.55,2.55,0,0,1-2.63.74l-8.59-3a2.11,2.11,0,0,0-2.42.9l-9.84,17a2.11,2.11,0,0,0,.43,2.54l6.9,5.94a2.56,2.56,0,0,1,.67,2.65,81.11,81.11,0,0,0-3.1,10.37,5,5,0,0,1-1.71,2.6L104.53,228a3.63,3.63,0,0,0-1.37,2.63V246a1.12,1.12,0,0,0,.46,1h0l10.06,5.85h0a1.1,1.1,0,0,0,1,0l6.92-3.12a3,3,0,0,1-.22,1.63l-7.94,16a1.8,1.8,0,0,0,.71,2.33l10,5.8,0,0,8.62,5a1.8,1.8,0,0,0,2.37-.56l9.89-14.88a2.94,2.94,0,0,1,1.34-1l.76,7.5a1.09,1.09,0,0,0,.5.9h0l10,5.84h0A1.08,1.08,0,0,0,158.84,278.23ZM178,185c2.29,2.43,3.58,6.48,3.58,12.12,0,14.42-10.12,32-22.61,39.16-4.58,2.65-8.6,3.78-11.85,3.46-2.63-2.75-4.19-7.07-4.19-12.71,0-14.42,10.13-31.95,22.62-39.16C170.14,185.16,174.41,184.28,178,185Z",
    id: "eli0uvc1icoj",
    className: "animable",
    style: {
      transformOrigin: "160.515px 211.02px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elrf41ygb127"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "130.437px 215.59px"
    },
    className: "animable",
    id: "ela95v7ezobum"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124,275.42a1.84,1.84,0,0,1-.51-2.21l7.94-16a2.45,2.45,0,0,0,.24-.9l-10-5.83a2.42,2.42,0,0,1-.22.88l-7.93,16a1.79,1.79,0,0,0,.69,2.33Zm33.72,2.9h0a.71.71,0,0,1-.28-.24.73.73,0,0,1-.19-.36,1.42,1.42,0,0,1-.06-.31l-1.3-13a1.21,1.21,0,0,0-.08-.34,1.39,1.39,0,0,0-.4-.62,1.48,1.48,0,0,0-.38-.23l-.22-.07a1.7,1.7,0,0,0-.71,0,1.71,1.71,0,0,1-.3.05,26.66,26.66,0,0,1-6.15.61,3.39,3.39,0,0,0-1.25.25l.75,7.52a1.16,1.16,0,0,0,.51.9h0Zm-44.15-25.5a1.16,1.16,0,0,1-.4-.95V236.41a3.61,3.61,0,0,1,.72-2l-10-5.81a3.57,3.57,0,0,0-.73,2V246a1.11,1.11,0,0,0,.44,1Zm41.93-76.76a4.21,4.21,0,0,0,.39-1.31l1.34-14.89a2.72,2.72,0,0,1,.38-1.18l-10-5.82a3.46,3.46,0,0,0-.4,1.17l-1.33,14.89a4.35,4.35,0,0,1-.4,1.31Zm-32,26.9a2,2,0,0,1,.06-1.87L133.44,184a2.07,2.07,0,0,1,1-.82l-10-5.82a2,2,0,0,0-1,.82l-9.83,17a2.1,2.1,0,0,0,0,2Z",
    id: "elm2rfhzljgta",
    className: "animable",
    style: {
      transformOrigin: "130.437px 215.59px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,268l1.34-14.89a5,5,0,0,1,1.4-2.78,80.72,80.72,0,0,0,7.43-7.87,2.58,2.58,0,0,1,2.63-.75l8.59,3a2.09,2.09,0,0,0,2.41-.89l9.84-17a2.07,2.07,0,0,0-.43-2.53l-6.89-5.94a2.58,2.58,0,0,1-.67-2.66,80.63,80.63,0,0,0,3.1-10.37,5,5,0,0,1,1.71-2.59l12.23-8.61a3.62,3.62,0,0,0,1.36-2.63V176a1,1,0,0,0-1.52-1l-11.91,5.37a1.42,1.42,0,0,1-2-.92,26.62,26.62,0,0,0-2.65-5.91,3.28,3.28,0,0,1-.18-2.88l7.94-16a1.8,1.8,0,0,0-.71-2.33l-8.61-5a1.82,1.82,0,0,0-2.38.55L186,162.78a3.29,3.29,0,0,1-2.59,1.28,26.68,26.68,0,0,0-6.45.66,1.41,1.41,0,0,1-1.78-1.26l-1.31-13a1,1,0,0,0-1.61-.83l-13.39,7.73a3.59,3.59,0,0,0-1.59,2.49l-1.34,14.9a5.09,5.09,0,0,1-1.39,2.78,79.62,79.62,0,0,0-7.44,7.87,2.55,2.55,0,0,1-2.63.74l-8.59-3a2.1,2.1,0,0,0-2.41.9l-9.84,17a2.1,2.1,0,0,0,.43,2.54l6.89,5.94a2.56,2.56,0,0,1,.67,2.65,81.11,81.11,0,0,0-3.1,10.37,5,5,0,0,1-1.71,2.6l-12.23,8.61a3.6,3.6,0,0,0-1.36,2.63v15.45a1,1,0,0,0,1.52,1l11.91-5.37a1.42,1.42,0,0,1,2,.91,26.62,26.62,0,0,0,2.65,5.91,3.3,3.3,0,0,1,.18,2.89l-7.94,16a1.8,1.8,0,0,0,.71,2.33l8.62,5a1.8,1.8,0,0,0,2.37-.56l9.89-14.88a3.3,3.3,0,0,1,2.59-1.29,27.16,27.16,0,0,0,6.45-.65,1.41,1.41,0,0,1,1.78,1.26l1.31,13a1,1,0,0,0,1.61.83l13.39-7.73A3.58,3.58,0,0,0,173.82,268Zm-8.28-28c-12.49,7.21-22.62,1.36-22.62-13.06s10.13-31.95,22.62-39.16,22.61-1.37,22.61,13.05S178,232.83,165.54,240Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "165.55px 213.915px"
    },
    id: "elfnjcrzmu32e",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-2",
    className: "animable",
    style: {
      transformOrigin: "362.315px 69.5746px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    className: "animable",
    style: {
      transformOrigin: "362.315px 69.5746px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    className: "animable",
    style: {
      transformOrigin: "362.315px 69.5746px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.94,94.78l2.69-5.07-2.17-6.26V79.62l6.64,3.83v3.83l-2.85,4.94a.43.43,0,0,1-.2.18h0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "364.52px 87.2px"
    },
    id: "elb1fpahu9l2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0ue9gmuqoh2e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.94,94.78l2.69-5.07-2.17-6.26V79.62l6.64,3.83v3.83l-2.85,4.94a.43.43,0,0,1-.2.18h0Z",
    style: {
      opacity: 0.2,
      transformOrigin: "364.52px 87.2px"
    },
    className: "animable",
    id: "el39xvdir4c3b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345.1,49.18a4.41,4.41,0,0,1,2-3.45l1.61-.93a4.37,4.37,0,0,1,4,0l24.84,14.36a4.41,4.41,0,0,1,2,3.45V89.93a4.41,4.41,0,0,1-2,3.45l-1.62.93a4.37,4.37,0,0,1-4,0l-8-4.61-2.84,4.93a.43.43,0,0,1-.77-.08l-3-8.68L347.08,80a4.43,4.43,0,0,1-2-3.45Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "362.315px 69.5746px"
    },
    id: "el6v42wmyfypp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpmvcabgkiwk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.51,89.93a4.41,4.41,0,0,1-2,3.45l-1.62.93a4.47,4.47,0,0,1-3.64.16c.94.36,1.65-.17,1.65-1.31V65.84a4,4,0,0,0-.58-2l5.59-3.23a4,4,0,0,1,.59,2Z",
    style: {
      opacity: 0.2,
      transformOrigin: "375.88px 77.696px"
    },
    className: "animable",
    id: "elhvimo8oi977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elb6jodcniv3j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.16,48.61c.23-.84,1-1.11,1.92-.58l24.84,14.36a4,4,0,0,1,1.4,1.49l5.6-3.23a4,4,0,0,0-1.4-1.48L352.69,44.8a4.43,4.43,0,0,0-4,0l-1.63.94A4.4,4.4,0,0,0,345.16,48.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "362.04px 54.1014px"
    },
    className: "animable",
    id: "elcdf0j0yv25s"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Like--inject-2",
    className: "animable",
    style: {
      transformOrigin: "358.955px 72.6699px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.07,70a4.09,4.09,0,0,0,1.44,2.58,3.17,3.17,0,0,0-.21,1.24,3.94,3.94,0,0,0,1.9,3l8.57,5V70.58s-2.36-5.37-2.57-6.15a24.48,24.48,0,0,1,0-4,2,2,0,0,0-2.3-1,1,1,0,0,0-.5.56,6.17,6.17,0,0,0-.52,1.78,9.11,9.11,0,0,0,.18,3.19l-5.19-3a1,1,0,0,0-1-.14,1.24,1.24,0,0,0-.54,1.12,3.83,3.83,0,0,0,.83,2.23s-1-.31-1,1.08a3.63,3.63,0,0,0,1.27,2.54S351.07,69,351.07,70Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "356.465px 70.5894px"
    },
    id: "el98boifsyya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.75,73.61V85.68c0,.27-.19.38-.42.24l-2.89-1.66a.94.94,0,0,1-.42-.73V71.47c0-.27.19-.38.42-.25l2.9,1.67A.88.88,0,0,1,367.75,73.61Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "365.885px 78.5732px"
    },
    id: "elw239jwmajz8",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-2",
    className: "animable",
    style: {
      transformOrigin: "76.89px 89.79px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Alert--inject-2",
    className: "animable",
    style: {
      transformOrigin: "76.89px 89.79px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bubble--inject-2",
    className: "animable",
    style: {
      transformOrigin: "76.89px 89.79px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.55,36.29C83.75,32.43,74.4,33,64.08,39,43.3,51,26.46,80.15,26.46,104.14c0,12,4.21,20.4,11,24.33,2.83,1.64,10,5.76,12.85,7.39,6.8,3.92,16.19,3.35,26.57-2.64,20.77-12,37.61-41.16,37.61-65.15,0-12-4.19-20.36-11-24.31C100.7,42.11,93.43,37.93,90.55,36.29Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "70.475px 86.0994px"
    },
    id: "elos20rakyah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eld6512ovojxi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.55,36.29C83.75,32.43,74.4,33,64.08,39,43.3,51,26.46,80.15,26.46,104.14c0,12,4.21,20.4,11,24.33,2.83,1.64,10,5.76,12.85,7.39,6.8,3.92,16.19,3.35,26.57-2.64,20.77-12,37.61-41.16,37.61-65.15,0-12-4.19-20.36-11-24.31C100.7,42.11,93.43,37.93,90.55,36.29Z",
    style: {
      opacity: 0.15,
      transformOrigin: "70.475px 86.0994px"
    },
    className: "animable",
    id: "elsqk50ul74e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhvowm7z6qy7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.89,
    cy: 89.79,
    rx: 53.2,
    ry: 30.71,
    style: {
      fill: "#3CB499",
      transformOrigin: "76.89px 89.79px",
      transform: "rotate(-60deg)"
    },
    className: "animable",
    id: "elsjcq6b9887"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.29,97.78s1.71,14.92,18.24,18.6c1.27.28,1.21,1.71.14,2.47-2.06,1.45-9.46,4.58-17.71,2.55-11.49-2.84-14.76-8-14.76-8Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "103.839px 109.923px"
    },
    id: "elmece7d6snr9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--alert--inject-2",
    className: "animable",
    style: {
      transformOrigin: "76.3389px 91.8745px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.49,65.42,55.71,116.74c-1.85,5.35.64,7.41,5.54,4.58l31.21-18a10.28,10.28,0,0,0,3.76-14L82,64.61C79.17,59.71,75.34,60.07,73.49,65.42Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "76.3389px 91.8745px"
    },
    id: "elogtue5ur2kg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.78,96.1l-2.71,1.56a.58.58,0,0,1-.95-.51L74,76.84a1.83,1.83,0,0,1,.84-1.54l5.13-3c.5-.28.87,0,.84.52l-1.1,21.7A2.12,2.12,0,0,1,78.78,96.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "77.4058px 84.993px"
    },
    id: "elj2ib13ipyns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.43,107c-1.73,1-2.77-.3-2.77-2.09a6.55,6.55,0,0,1,2.77-5.29c1.73-1,2.76.29,2.76,2.09A6.54,6.54,0,0,1,77.43,107Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "77.425px 103.309px"
    },
    id: "el0xv2qf30k77o",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screwdriver--inject-2",
    className: "animable",
    style: {
      transformOrigin: "94.4494px 399.06px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--screwdriver--inject-2",
    className: "animable",
    style: {
      transformOrigin: "94.4494px 399.06px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108,403c3.66-2.11,6.62-.4,6.62,3.82A14.65,14.65,0,0,1,108,418.31c-3.65,2.11-6.62.39-6.62-3.83A14.64,14.64,0,0,1,108,403Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "108px 410.654px"
    },
    id: "elahzvvyfumji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.62,353.28h0c-1.93-1.34-4.7-1.29-7.79.49-5.8,3.35-10.51,11.5-10.51,18.2,0,3.71,1.44,6.19,3.71,7.1h0c4.82,2.7,10.76.09,10.76.09l8.43-16.75C43.2,358,41.43,355,38.62,353.28Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "31.77px 366.32px"
    },
    id: "eltu79b5mt6n8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1sb7ipuh5f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.62,353.28h0c-1.93-1.34-4.7-1.29-7.79.49-5.8,3.35-10.51,11.5-10.51,18.2,0,3.71,1.44,6.19,3.71,7.1h0c4.82,2.7,10.76.09,10.76.09l8.43-16.75C43.2,358,41.43,355,38.62,353.28Z",
    style: {
      opacity: 0.1,
      transformOrigin: "31.77px 366.32px"
    },
    className: "animable",
    id: "el2s7bhiwuvsb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6olsoxwldsa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.49,370.88a13.46,13.46,0,0,1-11-5.15A18.84,18.84,0,0,0,20.31,372c0,3.71,1.44,6.19,3.71,7.1h0c4,2.26,8.84.81,10.31.27a1,1,0,0,1,.45-.18l2.72-5.41Z",
    style: {
      opacity: 0.1,
      transformOrigin: "28.905px 373.029px"
    },
    className: "animable",
    id: "elb7611egmg35"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129,416.77h0s-14.69-13.3-16.24-14.19L43.2,362.44h0c-1.2-.67-2.84-.57-4.65.48a14.61,14.61,0,0,0-6.62,11.46c0,2.11.74,3.59,1.93,4.28h0c.29.16,66.64,38.48,69.5,40.12s20.34,7,20.34,7h0a2.63,2.63,0,0,0,2.53-.3,8.11,8.11,0,0,0,3.68-6.37A2.71,2.71,0,0,0,129,416.77Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "80.9283px 393.996px"
    },
    id: "elnob3co3k2g8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell5jqzodv3p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.89,419.05a2.71,2.71,0,0,0-.92-2.28s-13.58-12.29-16-14c-1.22-.88-3-.86-5,.28a14.64,14.64,0,0,0-6.62,11.46c0,2.12.75,3.6,2,4.29h0c2.87,1.65,20.34,7,20.34,7h0a2.63,2.63,0,0,0,2.53-.3A8.11,8.11,0,0,0,129.89,419.05Z",
    style: {
      opacity: 0.1,
      transformOrigin: "115.625px 414.072px"
    },
    className: "animable",
    id: "el3479gsksntj"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.24,399.67c-1.2-.69-1.94-2.18-1.94-4.29a14.61,14.61,0,0,1,6.62-11.46c1.82-1.06,3.48-1.16,4.68-.47,0,0,3.83,1.56,16.31,8.11s10.19,7.19,10.19,7.19l-.9-.51c-1.2-.69-2.85-.59-4.68.46a14.61,14.61,0,0,0-6.62,11.46c0,2.11.74,3.6,1.94,4.29l1.2.69s-1.63.53-10.22-4.48A196.28,196.28,0,0,1,70.24,399.67Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "87.2825px 399.084px"
    },
    id: "eld6hinc8o7ho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.92,383.92c1.82-1.06,3.48-1.16,4.68-.47,0,0,3.83,1.56,16.31,8.11s10.19,7.19,10.19,7.19l-.9-.51c-1.2-.69-2.85-.59-4.68.46a11.6,11.6,0,0,0-2.81,2.35l-25.6-14.79A11.59,11.59,0,0,1,74.92,383.92Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "89.1875px 392.031px"
    },
    id: "el56onvb7u1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfej5e36cmne"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.53,423.3a8.14,8.14,0,0,1,3.68-6.38c2-1.17,3.68-.22,3.68,2.13a8.11,8.11,0,0,1-3.68,6.37C124.18,426.6,122.53,425.65,122.53,423.3Z",
    style: {
      opacity: 0.25,
      transformOrigin: "126.21px 421.173px"
    },
    className: "animable",
    id: "ele4h3atcr2re"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.57,445.37a.48.48,0,0,1-.22.39.16.16,0,0,1-.13,0h0c-.33-.11-5.29-1.94-6.84-2.59A2.62,2.62,0,0,1,161,443l-35.51-20.49a.78.78,0,0,1-.33-.71,2.24,2.24,0,0,1,.32-1.09,2.31,2.31,0,0,1,.77-.81.79.79,0,0,1,.77-.08l35.52,20.51a9.54,9.54,0,0,1,.95.68c1.74,1.32,4.85,4,5.08,4.22h0A.14.14,0,0,1,168.57,445.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "146.873px 432.764px"
    },
    id: "el0ubosb0gnji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.57,445.37a.48.48,0,0,1-.22.39.16.16,0,0,1-.13,0h0c-.33-.11-5.29-1.94-6.84-2.59.46-.43,1.44-.2,2.4.23s4.24,2.19,4.41,2-2.09-1.56-3.45-2.54-1.67-1.79-1.29-1.85c1.74,1.32,4.85,4,5.08,4.22h0A.14.14,0,0,1,168.57,445.37Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "164.978px 443.392px"
    },
    id: "el8ie64p9z9x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2m68w1yozmq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.6,420.28S162,440.62,162.51,441c.27.2.51.7,1.11,1.25a22.6,22.6,0,0,0,2.83,2c2.27,1.45-.6.17-3.13-1.55-.59-.4-.7-1.35-1.35-1.72-3-1.68-36.14-19.94-36.14-19.94S126.18,420.39,126.6,420.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "146.552px 432.58px"
    },
    className: "animable",
    id: "ellley5jrnyyj"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "404.705px 255.539px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "404.705px 255.539px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-2",
    className: "animable",
    style: {
      transformOrigin: "423.045px 318.768px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.71,369l2-17.64-20.09-1.81s.85,13.6.73,19.83c-.06,2.94-2.13,8.47-2.13,8.47s8.41,4.37,12.77,2.58,7.25-8.66,7.15-9.92S415.71,369,415.71,369Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "406.965px 365.205px"
    },
    id: "elik1amffvo4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.91,396.8c-.28,0-.49,2.56,1,3.82a19.87,19.87,0,0,0,14.11,3.23c6.72-1,10.34-3.09,13-5.36s6.38-5.47,9.42-6.19a21.86,21.86,0,0,0,7.52-3.87c.89-.88.69-4.71.69-4.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "395.69px 393.893px"
    },
    id: "elv59ffu007ct",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.72,369a1.07,1.07,0,0,1,1,.88c.23,1.05.51,4.12,1,5.85a30.81,30.81,0,0,1,.84,9.3c-.34,2-5.68,4.43-8.61,5.59a37.43,37.43,0,0,0-9.45,6.11c-3.12,2.63-9.74,5.42-14.14,5.47-5.2.05-11.08-1.51-12.47-3.86-1.71-2.91-3-6.3,4.66-10,1.45-.7,6.52-3.77,8.24-4.89,4.68-3,7.95-5.75,10-11a2.93,2.93,0,0,1,1.08-1.6,2.47,2.47,0,0,1,1.5-.16c1.29.15,6.42.76,7.6,1.29s2.53,1,2.53,2.31a4.31,4.31,0,0,1-.27,1.33c-.08.27-.15.63.09.78s.52,0,.72-.21a19.52,19.52,0,0,0,2-2.49,23.32,23.32,0,0,1,1.94-2.26,12.85,12.85,0,0,0,1.31-.86C415.83,370.19,415.7,369.62,415.72,369Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "395.602px 385.601px"
    },
    id: "eldqg372kczb7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.52,396.74c1.32-1.11,2.73-2.19,4.15-3.16h0s-9,5.59-12.68,3.18c-2.39-1.54-1.3-3.49-1.26-4.11s-8.37-4.82-10.67-5.05h0c-.63.36-1.15.66-1.49.81-6,2.47-6.72,5.54-5.65,9.37,1.38,2.35,6.65,4.71,13.37,4.59C390.69,402.29,397.4,399.37,400.52,396.74Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "388.589px 394.987px"
    },
    id: "ellxrquta9s5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.33,390.83c-4.76,2-2.7,2.82-1.35,3s9.33-4.62,14.18-8.54c5.06-4.09,9-9.53,10.84-11,.7-.56,1.46-1.24,2.12-1.88-.14-1-.26-2-.37-2.48a1.07,1.07,0,0,0-1-.88c0,.61.11,1.18-.35,1.65a12.85,12.85,0,0,1-1.31.86,23.32,23.32,0,0,0-1.94,2.26,20.24,20.24,0,0,1-2,2.49C406,381.58,396.09,388.86,391.33,390.83Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "402.738px 381.442px"
    },
    id: "elwx7wvytus2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.31,393.12a.5.5,0,0,0,.3-.11.46.46,0,0,0,.05-.66c-1.38-1.61-7.87-5.37-11.39-4.93a.47.47,0,0,0-.41.52.46.46,0,0,0,.53.41c3.29-.41,9.45,3.33,10.55,4.6A.48.48,0,0,0,390.31,393.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.817px 390.252px"
    },
    id: "elyvuq0zqv29h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.44,390.51a.48.48,0,0,0,.3-.11.46.46,0,0,0,.06-.66c-1.39-1.61-7.87-5.37-11.39-4.93a.47.47,0,1,0,.11.93c3.29-.4,9.46,3.33,10.55,4.6A.48.48,0,0,0,394.44,390.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "388.933px 387.642px"
    },
    id: "elwddafzg5cck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.58,388a.48.48,0,0,0,.3-.11.47.47,0,0,0,.06-.66c-1.39-1.61-7.87-5.37-11.4-4.93a.47.47,0,1,0,.12.93c3.29-.41,9.46,3.33,10.55,4.6A.5.5,0,0,0,398.58,388Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "393.073px 385.132px"
    },
    id: "elywgr6vgagla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.41,385.23a.5.5,0,0,0,.3-.11.46.46,0,0,0,.05-.66c-1.38-1.61-7.88-5.37-11.39-4.93a.46.46,0,0,0-.41.52.47.47,0,0,0,.53.41c3.28-.4,9.45,3.33,10.55,4.6A.48.48,0,0,0,402.41,385.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.916px 382.362px"
    },
    id: "el323lcfcpi3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.15,382.42a.48.48,0,0,0,.3-.11.45.45,0,0,0,.06-.65c-1.9-2.28-8.68-5.4-12.2-5a.46.46,0,1,0,.12.92c3.17-.39,9.66,2.61,11.35,4.63A.46.46,0,0,0,406.15,382.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "400.264px 379.523px"
    },
    id: "elloxvtfjjmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,377.32l-4.78-21.18,20.9-3.26.34,20.91s1.59,5.62.42,7.56-13.74,4-14.89,2.68S449,377.32,449,377.32Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "455.265px 368.664px"
    },
    id: "ell6qt58fr8zq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.1,410.71c.55,4.75,1.54,7.82,3.6,10.4s5.72,3,9.34,1.74,8.22-4.05,9.07-8.31.49-7.06-.56-11.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "462.342px 413.338px"
    },
    id: "elrx5d7o5c0mo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.47,373.79c1.51-.08,1.1,3.66,1.82,10.07.77,6.93,3.89,12.36,5,17.92,1.27,6.35,1,9.29-1.34,13.51s-11.23,9.17-16,4.11c-3.86-4.12-4.26-9.16-4.25-15.66a143.39,143.39,0,0,0-.47-16.47c-.53-4.81-2.55-9.25-1.26-9.95.14.7,1.42,5.57,2.27,5.49a8.63,8.63,0,0,0-.07-1.83,2,2,0,0,1,.34-1.61,7,7,0,0,1,2.43-1.24c1.48-.44,4.11-1,5.61-1.3.75-.15,1.51-.27,2.26-.36a6.56,6.56,0,0,1,1.93,0,1.18,1.18,0,0,1,.85.56,1.75,1.75,0,0,1,.11.72,4.84,4.84,0,0,0,.26,1.31c.06.18.22.4.44.33a.42.42,0,0,0,.22-.43C465.63,378.19,465.52,374.2,465.47,373.79Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "460.794px 397.665px"
    },
    id: "elgmkhkpiid8c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.86,400c.2.92,1.39,7-.45,8.33-2,1.46-3.37-3.26-3.37-3.26s-4.88-.72-11.76,2.86c.41,1-.51,4.4-2.47,3.93s-3.05-7.45-3.07-7.54c0,6.23.5,11.1,4.25,15.1,4.74,5.06,13.6.11,16-4.11s2.61-7.16,1.34-13.51C472.17,401.15,472,400.55,471.86,400Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "461.919px 410.781px"
    },
    id: "elltqw6kvy2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.51,405.53c.15,2.34,2.72,1.23,2.67-2.09s-1.79-11.36-2.45-16.78c-.44-7.8-.75-13-2.26-12.87,0,.08,0,.16,0,.24s.15,4.44.17,4.94c.28,4.77.34,14,1,18.32A65.76,65.76,0,0,1,467.51,405.53Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "467.825px 390.281px"
    },
    id: "eltt7u79uw3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.09,407.75a66.05,66.05,0,0,1-1.84-8c-.74-4.26-3.29-12.78-4.55-17.36-.41-.76-1.69-5-1.69-5-1.05.3,0,4.38.49,6.29s1.09,4,1.7,6.71c1.57,5.4,1.72,13.51,2.73,16.62S457.7,410,457.09,407.75Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "452.868px 393.393px"
    },
    id: "elenl0er2el",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.14,408.12a.7.7,0,0,0,.2-.08,20.69,20.69,0,0,1,11.58-2.49.62.62,0,0,0,.67-.44.46.46,0,0,0-.43-.56,21.57,21.57,0,0,0-12.38,2.68.49.49,0,0,0-.21.69A.55.55,0,0,0,456.14,408.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "462.052px 406.304px"
    },
    id: "eloj96hunmbsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.63,403.2a.67.67,0,0,0,.18-.07,25.64,25.64,0,0,1,13-2.78.63.63,0,0,0,.66-.46.46.46,0,0,0-.45-.54,26.68,26.68,0,0,0-13.71,2.94.52.52,0,0,0-.23.7A.55.55,0,0,0,454.63,403.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "461.25px 401.261px"
    },
    id: "elxzqw121u7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.18,395.57a.61.61,0,0,0,.46-.39.46.46,0,0,0-.38-.59c-6.87-1.2-13.42,2.67-13.69,2.83a.5.5,0,0,0-.21.7.59.59,0,0,0,.77.12c.06,0,6.42-3.79,12.81-2.66A.65.65,0,0,0,467.18,395.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "460.476px 396.346px"
    },
    id: "elussto38a0pm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.57,391.07a.59.59,0,0,0,.45-.38.45.45,0,0,0-.37-.59,20,20,0,0,0-14,2.83.48.48,0,0,0-.16.7.59.59,0,0,0,.78.07c.06,0,6-4,13-2.62A.7.7,0,0,0,466.57,391.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "459.722px 391.821px"
    },
    id: "ellphk26zsvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.86,386a.61.61,0,0,0,.45-.37.45.45,0,0,0-.36-.6c-7.09-1.46-13.78,2.79-14.06,3a.48.48,0,0,0-.17.7.58.58,0,0,0,.77.09c.07,0,6.53-4.15,13.11-2.79A.75.75,0,0,0,465.86,386Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "458.985px 386.826px"
    },
    id: "elpxat0xkcro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.44,214c2.88,37.6,4.14,93.69,4.14,93.69.26,2.85,1.89,6.85,3.21,20.93,1.4,14.86,1.35,36.07,1.35,36.07s-12.56,5.36-20.37,2.59c0,0-8.39-31.82-12.44-49.31-3.85-16.56-6.67-42.46-6.67-42.46l-4.56,25s.57,10.72.3,18.22c-.31,8.72-5,42.12-5,42.12s-11.67,7-19.79.33c0,0-3.95-49-4.21-59.52-.52-20.58-1.11-61.06,1.32-87.61Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "429.538px 291.037px"
    },
    id: "elc1y3emj2l14",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.66,275.46l-4.11-26.74s-9.45-1.44-14.31-6.11c0,0,3.15,6.19,12.06,8.58l4.08,24.34-2.28,24.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "417.45px 271.51px"
    },
    id: "elc4h6ranrmab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.35,365.36c-3.51,2.75-13.72,5.1-20.71,2.57l-1.41-5.9c5.28,1.78,16.15.65,22-3Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "455.29px 364.02px"
    },
    id: "elkjyk4u2lz99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.38,361.44c-2.37,2.4-13.34,4.38-19.82.59l-.47-5.93c4.91,2.74,16.19,2.27,21-.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "407.59px 359.855px"
    },
    id: "eladjbbidgfvv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.77,272.68s1.09,26.45,1,28.38-14.46,5.73-14.83,4.51c-.62-2-.46-6.59-1.71-28.5C457.17,275.53,460.77,272.68,460.77,272.68Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "453.503px 289.243px"
    },
    id: "el3m9m60ds6h5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.49,284.61a4.36,4.36,0,0,1,1.35-.11c.53,0,1.06,0,1.58-.08a26.62,26.62,0,0,0,3.32-.51,25.75,25.75,0,0,0,3.63-1.11c1-.37,1.87-.86,2.84-1.22.09,0,.1.14.05.18a13.58,13.58,0,0,1-3,1.54,21.4,21.4,0,0,1-3,1,25,25,0,0,1-3.31.59c-.55.06-1.11.1-1.67.12a3.6,3.6,0,0,1-1.76-.13C447.41,284.81,447.4,284.64,447.49,284.61Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "453.86px 283.322px"
    },
    id: "eltoyn8gw3e2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.58,281.6a.74.74,0,0,0,.25.6,1,1,0,0,0,1.55-1,.89.89,0,0,0-.36-.6,1,1,0,0,0-.72-.18c-.31,0-.42.2-.56.48A1.55,1.55,0,0,0,453.58,281.6Zm.6-.61a.56.56,0,0,1,.4-.1c.45.05.53.76.16,1a.57.57,0,0,1-.72-.14A.59.59,0,0,1,454.18,281Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "454.487px 281.393px"
    },
    id: "el4qjm2nssqbm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-2",
    className: "animable",
    style: {
      transformOrigin: "404.705px 187.017px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.93,162.24c-4,5.13-12.26,17.47-12.26,17.47S358.3,167,356.54,164.51c-3.52-4.91-4.38-9-9-10.15s-10.42-2.59-10.42-2.59l4.34,21.57c2,2.25,4.42,1.31,9.36,6.16,3.67,3.6,12.63,11.31,20.36,17.21,6.51,5,11.17,2.26,14.19-1.43,7.41-9,13.67-16.28,13.67-16.28l11-33.71C403.5,146.91,398.58,150,388.93,162.24Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "373.58px 172.361px"
    },
    id: "elwa6i0dddz6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.29,144.4c-9.44-.26-15.5,4.28-21.45,13.25-3.6,5.43-14.26,21.25-14.26,21.25l-13.09-9.1s-1.82,6-5.82,9c-3.47,2.6-6.39,1.15-6.39,1.15a118.35,118.35,0,0,0,14.15,13.26c9.9,8,13.25,8.69,17.65,5.35,2.18-1.66,3.62-3.46,7.76-8.24,5-5.75,8.57-10.61,8.57-10.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.785px 172.418px"
    },
    id: "elbg6tsbknyp6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-2",
    className: "animable",
    style: {
      transformOrigin: "426.756px 187.586px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.09,144.16s21.78,1.21,27.2,3.68c2.48,1.13,7.92,7.59,6.8,23.12-.46,6.25-3,19-3,23.68-.07,6.63,5.78,28.13,5.78,28.13-20.43,12.56-56.55,8.71-63.87,2,0,0,2.48-27.79,3.26-42.08,0,0-3.92-6.59-3.6-11,.47-6.51,1.83-8.83,7.79-16.11a122.55,122.55,0,0,1,10.19-11.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "426.756px 187.586px"
    },
    id: "elzui47g1burp",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M441.66,99.3c7,.78,8.73,12.26,7.06,18.74-3.22,12.49-11.65,14-12,19.29l-12.63-7.41-9.82-5.76c-.9-.53-1.8-1.06-2.68-1.63s-1.51-1.21-2.34-1.7c-.64-.38-1.29-.16-2-.35a3.87,3.87,0,0,1-1.67-1.49,8.38,8.38,0,0,1-1.23-2.23,8.59,8.59,0,0,1-.33-4.89,8.65,8.65,0,0,0-1.47,2.36,4.1,4.1,0,0,0-.11,2.74c-2.91-1.94-3.19-9.42,2.4-12.1,1-.47,1.63-2.11,2-3.09a11.6,11.6,0,0,1,1.15-2.41,24.21,24.21,0,0,1,1.64-2,28.4,28.4,0,0,1,3.8-3.47c4-3,10-5.9,15.17-4.76C434.22,90.35,440,93.52,441.66,99.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "424.856px 113.108px"
    },
    id: "elq1sttsuqx09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.45,142.33l.7-11.59a5.05,5.05,0,0,0,6.22-1.24c3.46-3.59,3.8-7.5,1.91-10-2.08-2.78-6.7-1.72-8.69,1.66-3,.72-4.24-3.59-1.95-8,0,0-14.59,1-21.35-10.1a3.66,3.66,0,0,0-5.89.92c-.72,1.65-1.65,4.4-1,10,.25,2.06-.75,4.53-.67,7.32.31,11,2.82,14.57,5.84,16.43a17,17,0,0,0,8.23,1.85l-.24,3h0c-.07,1.61-.45,1.66-1.85,1.74l-2.09.12s-8.45,10.67,2.09,12.12c11.57,1.6,23.16-6.46,25.68-10.17,0,0-.93-.16-3.49-.53S436.66,144.49,436.45,142.33Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "426.073px 129.363px"
    },
    id: "elk07hi7nny9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.17,126.73l-6,1.94a3.1,3.1,0,0,0,3.91,2.13A3.3,3.3,0,0,0,423.17,126.73Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "420.24px 128.835px"
    },
    id: "elk3o5jzqeid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.79,128.12a3.45,3.45,0,0,0-3.45,2.71,3.07,3.07,0,0,0,1.75,0,3.24,3.24,0,0,0,2.17-2.63A3.75,3.75,0,0,0,422.79,128.12Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "421.3px 129.538px"
    },
    id: "elu1jkhmb31bm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.44,111.73l4-1.77a2.08,2.08,0,0,0-2.8-1.14A2.27,2.27,0,0,0,408.44,111.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.361px 110.182px"
    },
    id: "eleb82rlze3du",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.81,115.09a1.86,1.86,0,0,1-1.66,2,1.75,1.75,0,0,1-1.95-1.59,1.87,1.87,0,0,1,1.66-2A1.75,1.75,0,0,1,412.81,115.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "411.005px 115.295px"
    },
    id: "elx8qve1mbk1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.41,113.33l-3.86-2.1a2.1,2.1,0,0,1,2.91-.93A2.3,2.3,0,0,1,427.41,113.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "425.599px 111.684px"
    },
    id: "el8di5nn2vazc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.51,115.48a1.87,1.87,0,0,1-1.66,2,1.75,1.75,0,0,1-2-1.59,1.87,1.87,0,0,1,1.66-2A1.74,1.74,0,0,1,426.51,115.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "424.68px 115.684px"
    },
    id: "el68zqh3895j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.62 111.83 418.33 124.2 412.3 121.01 419.62 111.83",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "415.96px 118.015px"
    },
    id: "eles3yp6o12",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.82,139.54c8,.13,13-2.79,15.19-7.6,0,0-.68,4.51-3.92,6.95-3.63,2.73-11.47,2.83-11.47,2.83Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "427.315px 136.83px"
    },
    id: "el0rrkfp5v3ykj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.73,144.25a61.19,61.19,0,0,0-17.42,36.37c-1.16,12-1.48,61.53-1.48,61.53s-6.93,0-10.14-2.32c1.88-27.48,3.8-54.39,5.14-68.15a28.21,28.21,0,0,1,4.72-12.42,56.72,56.72,0,0,1,13.74-14.86Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "403.21px 193.2px"
    },
    id: "el2s3171n7lcl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.84,209a82.67,82.67,0,0,0,8.38,1.78l.09-4.24a75.56,75.56,0,0,1-8.15-1.83C391.05,206.16,391,207.59,390.84,209Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "395.075px 207.745px"
    },
    id: "eldzyuyfh9vz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.05,221.4a76.26,76.26,0,0,1-8.94-2.09c-.1,1.42-.2,2.86-.3,4.3a80.17,80.17,0,0,0,9.19,2C399,224.28,399,222.86,399.05,221.4Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "394.43px 222.46px"
    },
    id: "el3ce1npl39qz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.9,144.14c-.64,10.32-3.73,23.42-3.87,34.56-.24,20.19,6,65,6,65s14.53-.21,23.62-6.6c.06-4.85-4.06-21.91-6.1-29s-2.83-16.05-.18-27.29.74-25.21-4.48-33.06Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "447.837px 193.92px"
    },
    id: "elak76liwwuaa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.08,228.44c11.91-.93,19.44-4.05,23.11-6-.29-1.31-.57-2.59-.91-3.91-4.78,2.46-14.64,5.11-22.69,5.82C436.76,225.75,436.92,227.12,437.08,228.44Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "448.39px 223.485px"
    },
    id: "elqsxj8sykd7q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.58,208.08c-.3-1-.57-2.14-.81-3.27a77.25,77.25,0,0,1-20.9,3.71c.14,1.41.28,2.81.43,4.2a81.88,81.88,0,0,0,21.51-3.82C456.73,208.61,456.65,208.34,456.58,208.08Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "445.84px 208.765px"
    },
    id: "elloswlxel17",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.89,115a23.16,23.16,0,0,1-2.09,6.34c-.44-.65-.94-1.29-1.46-1.92a38.83,38.83,0,0,0-10.64-8.65h0c-9.32-5.3-21.06-7.77-30.77-5.9a22.28,22.28,0,0,1,2.2-5.29A23.07,23.07,0,0,1,449.89,115Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "427.583px 104.642px"
    },
    id: "eldjzwkn0lf3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.79,91.33c-1.11-.65-6.77-2.85-7.22-3-2.93-1.16-7.76-1.48-13,2.2a23.37,23.37,0,0,0-8.76,11.9l6,2.43,2,.34c1.09-4.46,7.85-13.74,16.26-13.44a8,8,0,0,1,1.18.11,11.16,11.16,0,0,1,3.19.92,32,32,0,0,1,3,2.87A5.18,5.18,0,0,0,441.79,91.33Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "428.625px 96.3717px"
    },
    id: "ela14otldo7cg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el79z5ydp4yzx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.79,91.33c-1.11-.65-6.77-2.85-7.22-3-2.93-1.16-7.76-1.48-13,2.2a23.37,23.37,0,0,0-8.76,11.9l6,2.43,2,.34c1.09-4.46,7.85-13.74,16.26-13.44a8,8,0,0,1,1.18.11,11.16,11.16,0,0,1,3.19.92,32,32,0,0,1,3,2.87A5.18,5.18,0,0,0,441.79,91.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      transformOrigin: "428.625px 96.3717px"
    },
    className: "animable",
    id: "elkiyk8rdxry"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.72,105.19c1.28-5.2,10.31-17,20.63-12.42a31.63,31.63,0,0,1,3.06,2.87,5.21,5.21,0,0,0-2.62-4.31c-2.67-1.55-8.15-2.65-14.27,1.61a23.33,23.33,0,0,0-8.74,11.9Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "431.595px 97.571px"
    },
    id: "elgxw8pm6d5zl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxzk9v224kbq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.72,105.19c1.28-5.2,10.31-17,20.63-12.42a31.63,31.63,0,0,1,3.06,2.87,5.21,5.21,0,0,0-2.62-4.31c-2.67-1.55-8.15-2.65-14.27,1.61a23.33,23.33,0,0,0-8.74,11.9Z",
    style: {
      opacity: 0.3,
      transformOrigin: "431.595px 97.571px"
    },
    className: "animable",
    id: "elug32xxoatf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436,109c-.42-.43-2.19-5.22-9.52-9.92C422,96.16,412.3,95.26,408,95c-7.61-.49-9.55,1-9.73,2.1-.05.26-.25,1.48-.31,1.76a1,1,0,0,0,.1.73c1,1.82,6.9,5.29,6.9,5.29,9.71-1.87,21.45.6,30.77,5.9Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "416.966px 102.842px"
    },
    id: "elg92zmm05gih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4van5re93bj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436,109c-.42-.43-2.19-5.22-9.52-9.92C422,96.16,412.3,95.26,408,95c-7.61-.49-9.55,1-9.73,2.1-.05.26-.25,1.48-.31,1.76a1,1,0,0,0,.1.73c1,1.82,6.9,5.29,6.9,5.29,9.71-1.87,21.45.6,30.77,5.9Z",
    style: {
      opacity: 0.15,
      transformOrigin: "416.966px 102.842px"
    },
    className: "animable",
    id: "elfpnb94gb4zh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435.68,110.77c-9.32-5.3-21.06-7.77-30.77-5.9,0,0-5.9-3.47-6.9-5.29-.53-1,.21-3.4,9.62-2.8,4.35.28,14,1.18,18.54,4.08A25.92,25.92,0,0,1,435.68,110.77Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "416.781px 103.728px"
    },
    id: "eltr2lpvnxw3m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elf4qrdyew0p8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.68,110.77c-9.32-5.3-21.06-7.77-30.77-5.9,0,0-5.9-3.47-6.9-5.29-.53-1,.21-3.4,9.62-2.8,4.35.28,14,1.18,18.54,4.08A25.92,25.92,0,0,1,435.68,110.77Z",
    style: {
      opacity: 0.3,
      transformOrigin: "416.781px 103.728px"
    },
    className: "animable",
    id: "elne5c7ejq59b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.22,116.61l-5,1.37L349,140.43l-2.18,8.07-3.5-.63-9.91-22.66-5,1.37c-.22.6-.41,1.21-.58,1.86-3.09,11.46,1.25,27.61,9.69,36.08,4.26,4.28,8.74,5.76,12.53,4.73h0l5-1.37a7,7,0,0,0,.91-.31l89.13,88.2c.56,9.48,4.5,19.6,10.61,25.72,3.17,3.18,6.45,4.82,9.49,5l5-1.38-9.81-22.44,2.18-8.08,3.49.64L476,277.93l5-1.38c.21-.59.4-1.21.58-1.86,3.09-11.45-1.25-27.61-9.69-36.08-4.21-4.22-8.64-5.72-12.4-4.75h0l-.09,0h-.07l-4.84,1.33h0a7.91,7.91,0,0,0-1.07.36l-89.13-88.22c-.56-9.47-4.51-19.59-10.62-25.72C350.55,118.47,347.27,116.83,344.22,116.61Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "404.705px 201.55px"
    },
    id: "elb6uhg2229zk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el86lj1ni7t3p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.22,116.61l-5,1.37L349,140.43l-2.18,8.07-3.5-.63-9.91-22.66-5,1.37c-.22.6-.41,1.21-.58,1.86-3.09,11.46,1.25,27.61,9.69,36.08,4.26,4.28,8.74,5.76,12.53,4.73h0l5-1.37a7,7,0,0,0,.91-.31l89.13,88.2c.56,9.48,4.5,19.6,10.61,25.72,3.17,3.18,6.45,4.82,9.49,5l5-1.38-9.81-22.44,2.18-8.08,3.49.64L476,277.93l5-1.38c.21-.59.4-1.21.58-1.86,3.09-11.45-1.25-27.61-9.69-36.08-4.21-4.22-8.64-5.72-12.4-4.75h0l-.09,0h-.07l-4.84,1.33h0a7.91,7.91,0,0,0-1.07.36l-89.13-88.22c-.56-9.47-4.51-19.59-10.62-25.72C350.55,118.47,347.27,116.83,344.22,116.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "404.705px 201.55px"
    },
    className: "animable",
    id: "elbwifw39qyyj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elorwvhlyg4t"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "349 140.43 354.03 139.05 351.26 149.31 346.82 148.5 349 140.43",
    style: {
      fill: "#3CB499",
      opacity: 0.4,
      transformOrigin: "350.425px 144.18px"
    },
    className: "animable",
    id: "el549uxc3fgvs"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elq6djqhrp3y"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "466.07 255.27 471.1 253.89 463.16 252.45 462.57 254.63 466.07 255.27",
    style: {
      fill: "#3CB499",
      opacity: 0.4,
      transformOrigin: "466.835px 253.86px"
    },
    className: "animable",
    id: "elms07sf8ep7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpd3eg0hy24q"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "445.07 255.77 450.1 254.4 359.71 164.94 354.67 166.31 445.07 255.77",
    style: {
      fill: "#3CB499",
      opacity: 0.4,
      transformOrigin: "402.385px 210.355px"
    },
    className: "animable",
    id: "el2pvse9gz8o2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.72,236.82l-90.39-89.46c-.56-9.47-4.51-19.59-10.62-25.72-3.16-3.17-6.44-4.81-9.49-5L354,139.05l-2.76,10.26-7.95-1.44-9.91-22.66c-.21.59-.4,1.21-.58,1.86-3.09,11.46,1.25,27.61,9.69,36.08,6.19,6.21,12.85,6.54,17.19,1.79L450.1,254.4c.56,9.47,4.51,19.6,10.61,25.72,3.17,3.18,6.45,4.81,9.5,5l-9.81-22.44,2.76-10.26,7.94,1.44L481,276.55c.21-.59.4-1.21.58-1.86,3.09-11.45-1.25-27.61-9.69-36.08C465.72,232.41,459.06,232.07,454.72,236.82Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "407.19px 200.88px"
    },
    id: "elab6dm633h0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elea7vrmx1dqd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.72,236.82l-90.39-89.46c-.56-9.47-4.51-19.59-10.62-25.72-3.16-3.17-6.44-4.81-9.49-5L354,139.05l-2.76,10.26-7.95-1.44-9.91-22.66c-.21.59-.4,1.21-.58,1.86-3.09,11.46,1.25,27.61,9.69,36.08,6.19,6.21,12.85,6.54,17.19,1.79L450.1,254.4c.56,9.47,4.51,19.6,10.61,25.72,3.17,3.18,6.45,4.81,9.5,5l-9.81-22.44,2.76-10.26,7.94,1.44L481,276.55c.21-.59.4-1.21.58-1.86,3.09-11.45-1.25-27.61-9.69-36.08C465.72,232.41,459.06,232.07,454.72,236.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "407.19px 200.88px"
    },
    className: "animable",
    id: "eleab8jwgx1dm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrjleffgmgte"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.46,160.4l74.25,73.46a9.17,9.17,0,0,1,2.44,7.86c-.62,2.39-2.72,2.75-4.68.8L369.2,169a9.09,9.09,0,0,1-2.44-7.83C367.39,158.8,369.49,158.45,371.46,160.4Z",
    style: {
      fill: "#3CB499",
      opacity: 0.2,
      transformOrigin: "407.454px 201.457px"
    },
    className: "animable",
    id: "eluh9z99t1vd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elukbph4r6las"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.14,234.56,368.89,161.1a4.56,4.56,0,0,0-1.58-1.07,3.42,3.42,0,0,0-.55,1.15A9.09,9.09,0,0,0,369.2,169l74.27,73.51a4.54,4.54,0,0,0,1.57,1.06,3.34,3.34,0,0,0,.54-1.17A9.13,9.13,0,0,0,443.14,234.56Z",
    style: {
      fill: "#3CB499",
      opacity: 0.2,
      transformOrigin: "406.17px 201.8px"
    },
    className: "animable",
    id: "elxzwsooiodto"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5hzvnyfxa2g"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "462.57 254.63 463.16 252.45 471.1 253.89 481.02 276.55 475.98 277.93 466.07 255.27 462.57 254.63",
    style: {
      fill: "#3CB499",
      opacity: 0.2,
      transformOrigin: "471.795px 265.19px"
    },
    className: "animable",
    id: "elj107mmq5yqe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2bplqzj27xo"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "344.22 116.61 354.03 139.05 351.26 149.31 354.93 139.07 344.22 116.61",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "349.575px 132.96px"
    },
    className: "animable",
    id: "elwury0si7qf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpgv1perred8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "470.2 285.15 459.28 262.72 463.16 252.45 460.4 262.71 470.2 285.15",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "464.74px 268.8px"
    },
    className: "animable",
    id: "eluxxg01uqbh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425.22,205.91c-2.82-2.41-3.58-2.67-6.57-2.78s-4.36-.18-5.52-.12a24.38,24.38,0,0,0-5.94,1.44c-1.38.86.76,2.94,3,2.88s5.18-.36,5.18-.36Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "415.987px 205.16px"
    },
    id: "elbx3t83bduif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.24,148.24c9.07,2.41,14.34,5.61,16.22,10.31,3.32,8.33,10.75,34.24,11.91,41s.57,8.54-5,11.62c-4.63,2.57-23.86,8.37-32.74,10.73a7.92,7.92,0,0,1-6.93-1.44L427.54,214l33.67-15.91-7.62-22.84S446.27,158.93,452.24,148.24Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "454.202px 185.201px"
    },
    id: "elsreopxzggu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.92,147.73c5.95,1.7,10.92,3.53,13.75,6.42,4,4.07,3.48,4,8.8,20.83s6.87,25.16,7.24,28.53-.08,4.85-5.3,7.73-19.84,6.64-19.84,6.64a33.05,33.05,0,0,0-2.09-9.78c-1.84-4.4-4.48-4.67-4.48-4.67l10.27-5.67S454,180,451.69,174.08,446.59,157.88,451.92,147.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "465.336px 182.805px"
    },
    id: "el6gx80fzzt7c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.14,216.67c-1-.18-1.34-4.3-3-4.89s-1.89-.35-2.72-1.95-2-2.22-3.05-2.13-.64-1.81-2.53-2.28a33.71,33.71,0,0,0-7.34-.12c-1.72.17-5.63,2.66-7.31,3.86s-.51,2.33.55,2.88,3.15.06,3.15.06-1.72,1.53-1.32,2.24c.53.93,2.3,1.74,4.77.68-1.61,1.12-1.43,2.2-.09,2.74,1,.42,2.51.22,4.25-.42,2.19-.81,5.12-1.79,6.85-1.08l1.71,1.34Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "424.743px 211.568px"
    },
    id: "eluq3n9icwmxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.14,216.67c-.44,0-.68-.49-.9-.8a8.34,8.34,0,0,1-.55-1.07,14.36,14.36,0,0,0-1-2,1.64,1.64,0,0,0-.66-.63l-1.08-.43a2.1,2.1,0,0,1-1.05-.77,4.3,4.3,0,0,1-.47-1.14,7.33,7.33,0,0,0,.79.86,1.93,1.93,0,0,0,.94.42c.37.08.76.18,1.15.3a2.33,2.33,0,0,1,1.09.89,8.16,8.16,0,0,1,.94,2.27l.3,1.13A1.55,1.55,0,0,0,438.14,216.67Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "435.285px 213.25px"
    },
    id: "el2jfv1hmmwei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.88,212.1c.88-.7,1.76-1.39,2.68-2a18.35,18.35,0,0,1,2.92-1.79,14.45,14.45,0,0,1,3.43-.48,23.71,23.71,0,0,1,3.37,0q-1.65.38-3.3.63l-1.64.28a10.11,10.11,0,0,0-1.54.33c-.93.41-1.91,1.05-2.89,1.56A24.92,24.92,0,0,1,415.88,212.1Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "422.08px 209.935px"
    },
    id: "el5i9x7mvvvzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.2,211.53c-1.05.16-2.14.18-3.15.25a8.57,8.57,0,0,0-2.88.84c-1.91.83-3.82,1.73-5.84,2.4a28.45,28.45,0,0,1,5.5-3.19,7.14,7.14,0,0,1,3.2-.72A25.44,25.44,0,0,1,431.2,211.53Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "425.265px 213.065px"
    },
    id: "el0npjw97a3ue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.93,160.68c-2.14-2.77-2.35-3.49-2.31-6.31s0-4.11.14-5.21a23.31,23.31,0,0,1,1.63-5.52c.88-1.26,2.73.85,2.57,3s-.58,4.86-.58,4.86Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "331.793px 151.971px"
    },
    id: "eluiwiakd9bx7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.47,173.34c-.13-.94-4-1.46-4.47-3.05s-.24-1.8-1.71-2.65a3.13,3.13,0,0,1-1.86-3c.12-.95-1.67-.68-2-2.49a31.26,31.26,0,0,1,.22-6.92c.24-1.61,2.77-5.16,4-6.69s2.22-.37,2.68.65a5.6,5.6,0,0,1-.08,3s1.51-1.54,2.16-1.13c.85.54,1.54,2.24.42,4.52,1.13-1.47,2.14-1.25,2.59,0a6,6,0,0,1-.6,4c-.86,2-1.77,4.94-1.19,6.61l1.68,2.43Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "337.433px 160.57px"
    },
    id: "elcdjbratpruk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.2,152.17c-.71.8-1.4,1.6-2.05,2.43a17.89,17.89,0,0,0-1.82,2.67,14.52,14.52,0,0,0-.61,3.2,26,26,0,0,0-.13,3.18c.29-1,.54-2.05.76-3.08l.33-1.53a9.48,9.48,0,0,1,.39-1.43c.43-.86,1.07-1.75,1.6-2.65A25,25,0,0,0,338.2,152.17Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "335.892px 157.91px"
    },
    id: "elm9vfjmnxa1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,166.57c.2-1,.26-2,.38-2.95a8.05,8.05,0,0,1,.92-2.68c.87-1.75,1.8-3.51,2.53-5.38a26.91,26.91,0,0,0-3.26,5,6.77,6.77,0,0,0-.82,3A24.77,24.77,0,0,0,337,166.57Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "338.79px 161.065px"
    },
    id: "elexbgcirvcq7",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cone--inject-2",
    className: "animable",
    style: {
      transformOrigin: "330.566px 426.19px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cone--inject-2",
    className: "animable",
    style: {
      transformOrigin: "330.566px 426.19px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.5,436.38l-29-16.74a4.34,4.34,0,0,0-3.89,0l-29,16.74a1.36,1.36,0,0,0-.8,1.12v2.11a1.37,1.37,0,0,0,.8,1.13l29,16.72a4.26,4.26,0,0,0,3.89,0l29-16.72a1.37,1.37,0,0,0,.8-1.13V437.5A1.36,1.36,0,0,0,361.5,436.38Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "330.555px 438.555px"
    },
    id: "elwjr9t0z2fm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvaltuw0oac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.3,437.5v2.11a1.37,1.37,0,0,1-.8,1.13l-29,16.72a3.87,3.87,0,0,1-1.94.47V419.18a4,4,0,0,1,1.94.46l29,16.74A1.36,1.36,0,0,1,362.3,437.5Z",
    style: {
      opacity: 0.1,
      transformOrigin: "346.43px 438.555px"
    },
    className: "animable",
    id: "elhx2h698emi6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltxw262bvz7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.58,419.18v38.75a3.91,3.91,0,0,1-1.95-.47l-29-16.72a1.37,1.37,0,0,1-.8-1.13V437.5a1.36,1.36,0,0,1,.8-1.12l29-16.74A4,4,0,0,1,330.58,419.18Z",
    style: {
      opacity: 0.3,
      transformOrigin: "314.705px 438.555px"
    },
    className: "animable",
    id: "el1vm2yv8ayiv"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.63,455.36l-29-16.73a1.19,1.19,0,0,1,0-2.25l29-16.73a4.3,4.3,0,0,1,3.89,0l29,16.73a1.19,1.19,0,0,1,0,2.25l-29,16.73A4.32,4.32,0,0,1,328.63,455.36Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "330.575px 437.504px"
    },
    id: "elul9g41b2gjg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhnmwm63n7vf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.63,455.36l-29-16.73a1.19,1.19,0,0,1,0-2.25l29-16.73a4.3,4.3,0,0,1,3.89,0l29,16.73a1.19,1.19,0,0,1,0,2.25l-29,16.73A4.32,4.32,0,0,1,328.63,455.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "330.575px 437.504px"
    },
    className: "animable",
    id: "elrjp5qee1u4d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1ctwwvk9wub"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.58,419.18a4,4,0,0,0-1.95.47l-29,16.73a1.19,1.19,0,0,0,0,2.25l29,16.73a4,4,0,0,0,1.95.46Z",
    style: {
      opacity: 0.05,
      transformOrigin: "314.704px 437.5px"
    },
    className: "animable",
    id: "el7wg068nlvj9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.47,435.39h0l-12.82-38.51v-.06h0a2.88,2.88,0,0,0-1.39-1.49,8,8,0,0,0-7.3,0,3,3,0,0,0-1.4,1.49h0v0h0l-12.83,38.52h0c-1.18,3.35.47,7,5,9.57,7.14,4.12,18.7,4.12,25.83,0C348,442.36,349.65,438.74,348.47,435.39Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "330.6px 421.224px"
    },
    id: "elhxpzogb47qp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.33,407.92l0,0-1.82-5.47a2.64,2.64,0,0,1-.8,2.75,5,5,0,0,1-1.14.87,11,11,0,0,1-9.95,0,5.26,5.26,0,0,1-1.14-.87,2.66,2.66,0,0,1-.79-2.76l-1.83,5.49v0a3.17,3.17,0,0,0,.4,2.75,5.85,5.85,0,0,0,2,1.85,10.67,10.67,0,0,0,2.21.91,14.92,14.92,0,0,0,8.17,0,10.76,10.76,0,0,0,2.22-.91,5.81,5.81,0,0,0,2-1.85A3.14,3.14,0,0,0,339.33,407.92Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "330.587px 408.225px"
    },
    id: "elk4ukq6pgnrn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.67,430v0l-1.82-5.48a5,5,0,0,1,.1,2.76,6.3,6.3,0,0,1-1.55,2.77,10.82,10.82,0,0,1-2.54,2c-5.67,3.28-14.87,3.28-20.54,0a10.89,10.89,0,0,1-2.55-2,6.38,6.38,0,0,1-1.54-2.77,4.86,4.86,0,0,1,.1-2.75L314.5,430l0,.05a5.64,5.64,0,0,0-.2,2.76c.37,2.08,1.94,4.11,4.71,5.71,6.4,3.7,16.78,3.7,23.18,0,2.77-1.6,4.33-3.63,4.71-5.71A5.56,5.56,0,0,0,346.67,430Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "330.599px 432.907px"
    },
    id: "elgxdcn3ny21h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,419v0l-1.83-5.48a3.7,3.7,0,0,1-.17,2.75,6.42,6.42,0,0,1-2.71,2.76l-.08.06A16.84,16.84,0,0,1,323,419l-.09-.06a6.42,6.42,0,0,1-2.71-2.76,3.75,3.75,0,0,1-.17-2.75l-1.82,5.48,0,0a4.31,4.31,0,0,0,0,2.77,6.23,6.23,0,0,0,2,2.74,10.46,10.46,0,0,0,1.46,1,16.21,16.21,0,0,0,4.86,1.74,21.59,21.59,0,0,0,8.17,0,16,16,0,0,0,4.86-1.74,10,10,0,0,0,1.47-1,6.3,6.3,0,0,0,2-2.74A4.38,4.38,0,0,0,343,419Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "330.603px 420.49px"
    },
    id: "elt1m11nirsp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elf51goa1wzcp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.58,394.45a7.47,7.47,0,0,0-3.65.88,3,3,0,0,0-1.4,1.49h0v0h0l-12.83,38.52h0c-1.18,3.35.47,7,5,9.57a26.4,26.4,0,0,0,12.92,3.09l-.11,0a10.84,10.84,0,0,1-8.88-12.25l5.34-38.34Z",
    style: {
      opacity: 0.1,
      transformOrigin: "321.476px 421.227px"
    },
    className: "animable",
    id: "elcexd0h437wg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,399.54c-2-1.16-2-3.05,0-4.21a8,8,0,0,1,7.3,0c2,1.16,2,3.05,0,4.21A8,8,0,0,1,326.93,399.54Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "330.58px 397.435px"
    },
    id: "elvy6nig8x62g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmbx9xpof5t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.93,399.54c-2-1.16-2-3.05,0-4.21a8,8,0,0,1,7.3,0c2,1.16,2,3.05,0,4.21A8,8,0,0,1,326.93,399.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "330.58px 397.435px"
    },
    className: "animable",
    id: "els434xdwvx4e"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformatique);
export default __webpack_public_path__ + "static/media/informatique.b012b9dcc55a0137875fcf9f63a0907d.svg";
export { ForwardRef as ReactComponent };